// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/svg/orange.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/svg/greenbg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/svg/errorbg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700&family=Montserrat:wght@700&family=Poppins:wght@100;200;300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-full-container {
  background: #e6e8ec;
}

:root {
  --gray-300: #d0d5dd;
  --gray-500: #667085;
  --white: #ffffff;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  padding: 0;
  margin: 0;
  color: #444;
  font-family: "Poppins", sans-serif;
}

a {
  color: inherit;
  text-decoration: none;
  cursor: default;
}

.default-cursor {
  cursor: default;
}

.svg-container:hover path {
  fill: #007eff;
}

.tooltip-container:hover path {
  fill: #000;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background: rgba(207, 207, 207, 0.22);
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 1px solid var(--gray-300, #e6e6e6);
  background: #fff;
}

.white-focusable {
  outline: none;
}
.white-focusable:focus {
  box-shadow: 0 0 10px 5px rgba(255, 255, 255, 0.7);
  border-radius: 5%;
}

.blue-focusable {
  outline: none;
}
.blue-focusable:focus {
  box-shadow: 0 0 10px 5px rgba(0, 123, 255, 0.5);
  border-radius: 5%;
}

.css-1ufnqyr-MuiFormControl-root-MuiTextField-root {
  width: 170px !important;
}

ul li.MuiButtonBase-root.MuiMenuItem-root.MuiTablePagination-menuItem {
  color: #000;
}

.orange-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 212px 212px;
}

.green-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 212px 212px;
}

.error-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 212px 212px;
}

.MuiTextField-root {
  background: none !important;
}

.MuiMenuItem-root.Mui-selected {
  background: none !important;
}

.MuiSnackbar-root {
  z-Index: 1800;
}

.MuiBackdrop-root {
  opacity: 0.75 !important;
  background: #000 !important;
}

.MuiBackdrop-invisible {
  opacity: 1 !important;
  background: transparent !important;
}

.rotating-icon {
  animation: rotate 1s infinite linear;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.MuiMenu-paper ul.MuiList-root li {
  color: #000;
}

.MuiAppBar-positionFixed.mui-fixed {
  height: calc(50px + 2vw);
}

.main-full-container {
  margin-top: calc(50px + 1.5vw) !important;
}

@media (max-width: 1710px) {
  div.expand-domain-ui,
  div.expand-domain-setup-ui {
    gap: 60px;
  }
}
@media (max-width: 1629px) {
  .setup-complete-title {
    font-size: 50px !important;
  }
}
@media (max-width: 1521px) {
  .setup-complete-title {
    font-size: 30px !important;
  }
  .setup-complete-subtitle {
    font-size: 16px !important;
  }
}
@media (max-width: 1391px) {
  div.expand-domain-ui,
  div.expand-domain-setup-ui {
    flex-wrap: nowrap;
  }
  div.expand-domain-ui .setup-complete-title,
  div.expand-domain-setup-ui .setup-complete-title {
    font-size: 40px !important;
  }
}
@media (max-width: 2560px) {
  div[data-testid=adv-setup-stepper] span.MuiStepConnector-line {
    min-height: 58px !important;
  }
}
@media (max-width: 1472px) {
  div.create-domain-setup-left-stepper {
    padding: 30px 60px;
    min-width: 375px;
    max-width: 375px;
  }
}
@media (max-width: 1280px) {
  .create-organization,
  .create-application,
  .create-permission,
  .create-role {
    gap: 20px !important;
  }
  .create-organization .caption-boxes,
  .create-application .caption-boxes,
  .create-permission .caption-boxes,
  .create-role .caption-boxes {
    width: 35%;
  }
}
@media (max-width: 1440px) {
  div[data-testid=adv-setup-stepper] .MuiStepLabel-label, div[data-testid=adv-setup-stepper] .Mui-active, div[data-testid=adv-setup-stepper] .Mui-completed {
    font-size: 12px !important;
  }
  div[data-testid=adv-setup-stepper] span.MuiStepConnector-line {
    min-height: 24px !important;
  }
  div.expand-domain-ui,
  div.expand-domain-setup-ui {
    gap: 40px;
  }
  div.expand-domain-ui .MuiStepLabel-label, div.expand-domain-ui .Mui-active, div.expand-domain-ui .Mui-completed,
  div.expand-domain-setup-ui .MuiStepLabel-label,
  div.expand-domain-setup-ui .Mui-active,
  div.expand-domain-setup-ui .Mui-completed {
    font-size: 14px !important;
  }
  div.create-domain-setup-left-stepper {
    padding: 30px 60px;
    min-width: 375px;
    max-width: 375px;
  }
  div.create-domain-left-stepper {
    padding: 30px 50px;
    max-width: 300px;
  }
  div.create-domain-left-stepper .MuiStepLabel-label, div.create-domain-left-stepper .Mui-active {
    font-size: 14px !important;
  }
  div.create-domain-right div.create-form-wrapper {
    gap: 20px;
  }
  div.create-domain-right div.create-form-wrapper .step-container {
    height: 30px;
  }
  div.create-domain-right .step-name {
    font-size: 12px !important;
  }
  div[data-testid=create-group],
  div[data-testid=assign-users-to-org],
  div[data-testid=map-per-to-role],
  div[data-testid=map-role-to-user] {
    overflow: auto;
  }
  div.create-domain-adv-right div.create-form-wrapper {
    gap: 20px;
  }
  div.create-domain-adv-right div.create-form-wrapper .step-container {
    height: 30px;
  }
  div.create-domain-adv-right div.create-form-wrapper .step-name {
    font-size: 12px !important;
  }
  div.create-domain-adv-right div.create-form-wrapper .create-domain-step,
  div.create-domain-adv-right div.create-form-wrapper .user-onboarding,
  div.create-domain-adv-right div.create-form-wrapper .create-organization {
    height: calc(100vh - 310px);
  }
  div.create-domain-adv-right div.create-form-wrapper .create-application {
    height: calc(100vh - 415px);
  }
  div.create-domain-adv-right div.create-form-wrapper .create-application .border-dark {
    margin: 15px 0px 15px 0px;
  }
  div.create-domain-adv-right div.create-form-wrapper .create-permission,
  div.create-domain-adv-right div.create-form-wrapper .create-role {
    min-height: calc(100vh - 375px);
  }
  div.create-domain-adv-right div.create-form-wrapper .create-group,
  div.create-domain-adv-right div.create-form-wrapper .assign-user-to-org {
    min-height: calc(100vh - 320px);
  }
  div.create-domain-adv-right div.create-form-wrapper .map-per-to-roles,
  div.create-domain-adv-right div.create-form-wrapper .map-role-to-user {
    min-height: calc(100vh - 300px);
  }
  div.create-domain-adv-right div.create-form-wrapper .map-per-to-roles button[data-testid=add-btn],
  div.create-domain-adv-right div.create-form-wrapper .map-role-to-user button[data-testid=add-btn] {
    height: 40px !important;
    font-size: 12px;
  }
  div.create-domain-adv-right div.create-form-wrapper .choose-wrapper {
    height: auto;
  }
  div.create-domain-adv-right div.create-form-wrapper .choose-wrapper button.create-form-btn {
    height: 35px;
  }
  div.create-domain-adv-right div.create-form-wrapper div.top-left-btns .MuiOutlinedInput-root {
    height: 40px !important;
  }
  div.create-domain-adv-right div.create-form-wrapper div.top-left-btns .filter-btn {
    height: 40px !important;
    width: 40px !important;
  }
  div.create-domain-adv-right div.create-form-wrapper div.top-left-btns button[data-testid=add-btn] {
    height: 40px !important;
    font-size: 12px;
  }
  div.create-domain-adv-right div.create-form-wrapper div.top-right-btns button[data-testid=remove-btn],
  div.create-domain-adv-right div.create-form-wrapper div.top-right-btns button[data-testid=remove-admin-btn],
  div.create-domain-adv-right div.create-form-wrapper div.top-right-btns button[data-testid=promote-admin-btn] {
    height: 40px !important;
    font-size: 12px;
  }
  div.create-domain-adv-right div.create-form-wrapper .empty-space {
    height: 40px !important;
  }
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-left-side], div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-right-side],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-left-side], div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-right-side],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-left-side], div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-right-side],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-left-side], div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-right-side] {
    gap: 16px;
  }
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-left-side] .custom-pagination, div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-right-side] .custom-pagination,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-left-side] .custom-pagination, div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-right-side] .custom-pagination,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-left-side] .custom-pagination, div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-right-side] .custom-pagination,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-left-side] .custom-pagination, div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-right-side] .custom-pagination {
    height: 50px;
  }
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-left-side] .custom-pagination .MuiTablePagination-root, div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-right-side] .custom-pagination .MuiTablePagination-root,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-left-side] .custom-pagination .MuiTablePagination-root, div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-right-side] .custom-pagination .MuiTablePagination-root,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-left-side] .custom-pagination .MuiTablePagination-root, div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-right-side] .custom-pagination .MuiTablePagination-root,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-left-side] .custom-pagination .MuiTablePagination-root, div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-right-side] .custom-pagination .MuiTablePagination-root {
    margin-left: 0px;
  }
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"], div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"], div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"], div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-left-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"], div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="previous page"],
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-right-side] .custom-pagination .MuiTablePagination-root button[aria-label="next page"] {
    height: 40px !important;
    margin-top: 7px;
    font-size: 14px !important;
  }
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-left-side] .setup-checkbox-button .button-content, div.create-domain-adv-right div.create-form-wrapper div[data-testid=group-right-side] .setup-checkbox-button .button-content,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-left-side] .setup-checkbox-button .button-content, div.create-domain-adv-right div.create-form-wrapper div[data-testid=org-right-side] .setup-checkbox-button .button-content,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-left-side] .setup-checkbox-button .button-content, div.create-domain-adv-right div.create-form-wrapper div[data-testid=permap-right-side] .setup-checkbox-button .button-content,
  div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-left-side] .setup-checkbox-button .button-content, div.create-domain-adv-right div.create-form-wrapper div[data-testid=rolemap-right-side] .setup-checkbox-button .button-content {
    display: none;
  }
  div.create-domain-adv-right div.create-form-wrapper div.footer-buttons button.cross-btn,
  div.create-domain-adv-right div.create-form-wrapper div.footer-buttons button[data-testid=tick-btn],
  div.create-domain-adv-right div.create-form-wrapper div.footer-buttons button[data-testid=left-btn],
  div.create-domain-adv-right div.create-form-wrapper div.footer-buttons button[data-cy=right-btn] {
    width: 40px;
    height: 40px;
    padding: 10px;
  }
  div.search-export-section .search-bar {
    width: 260px;
  }
  .main-full-container {
    margin-top: calc(50px + 1vw) !important;
  }
  .outlet-box {
    max-height: calc(100vh - 200px);
  }
  .MuiAppBar-positionFixed.mui-fixed {
    height: 70px;
  }
  .MuiAppBar-positionFixed.mui-fixed .MuiBreadcrumbs-li > div {
    font-size: 14px;
  }
  .MuiAppBar-positionFixed.mui-fixed a.MuiListItemButton-root {
    height: 70px !important;
  }
  .MuiDrawer-paperAnchorLeft .MuiListItemButton-root {
    height: 70px !important;
  }
  .create-user-page {
    height: calc(100vh - 120px);
    overflow: auto;
  }
  .roles-permission-list {
    height: calc(100vh - 382px) !important;
  }
  .main-sub-container {
    height: calc(100vh - 200px);
    overflow: auto;
  }
  .custom-pagination {
    padding: 8px 16px !important;
  }
  .user-panel-table {
    height: calc(100vh - 300px) !important;
  }
  .panel-table {
    height: calc(100vh - 300px) !important;
  }
  div[data-testid=dom-admin-left-panel], div[data-testid=prev-right-panel],
  div[data-testid=left-panel],
  div[data-testid=right-panel],
  div[data-testid=adv-api-mgmt],
  div.main-side-drawer {
    max-height: calc(100vh - 200px);
    min-height: calc(100vh - 200px);
  }
  div.create-group-form {
    height: calc(100vh - 300px) !important;
  }
  div.main-side-drawer {
    gap: 8px;
  }
  div.drawer-header {
    padding: 0px;
  }
  div.resource-table {
    max-height: calc(100vh - 510px);
  }
  div.subscriber-table {
    height: calc(100vh - 530px);
  }
  div[data-testid=main-auth-container] {
    height: calc(100vh - 140px);
  }
  div[data-testid=domadmins-list] div.user-div .user-div {
    height: 50px;
  }
  .MuiTablePagination-root .MuiTablePagination-toolbar {
    padding-left: 0px !important;
  }
  .MuiTablePagination-root .MuiTablePagination-selectLabel, .MuiTablePagination-root .MuiTablePagination-select,
  .MuiTablePagination-root .MuiTablePagination-displayedRows {
    font-size: 14px !important;
  }
  .MuiTablePagination-root .MuiTablePagination-input {
    margin-right: 20px !important;
  }
  .MuiTablePagination-root div.MuiBox-root {
    margin-left: 20px !important;
  }
  .MuiTablePagination-root div.MuiBox-root button[aria-label="next page"] {
    margin-left: 20px !important;
  }
}
body[data-theme=dark] .main-full-container {
  background: #111;
}
body[data-theme=dark] div#root > div {
  background: #111;
  color: #FFF;
}
body[data-theme=dark] .svg-container path {
  fill: #FFF;
}
body[data-theme=dark] .svg-container:hover path {
  fill: #007eff;
}
body[data-theme=dark] header {
  background-color: #1B1B1B;
}
body[data-theme=dark] header .MuiBreadcrumbs-ol .MuiBreadcrumbs-li div.last-crumb {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] header .MuiBreadcrumbs-ol li.MuiBreadcrumbs-separator svg path {
  fill: var(--gray-white, #FFF);
}
body[data-theme=dark] header .head-dom-name {
  border: none;
  background: #2F2F2F;
}
body[data-theme=dark] header .head-dom-name svg path {
  stroke: var(--gray-white, #FFF);
}
body[data-theme=dark] header .head-dom-name p {
  color: #FFF;
}
body[data-theme=dark] header button[aria-controls=primary-search-account-menu] {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
body[data-theme=dark] header button[aria-controls=primary-search-account-menu]:hover {
  background: #2F2F2F;
}
body[data-theme=dark] .MuiDrawer-paper {
  background-color: #1B1B1B;
}
body[data-theme=dark] .MuiDrawer-paper div.select-org-dropdown {
  background: #272727 !important;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.15) !important;
}
body[data-theme=dark] .MuiDrawer-paper div.select-org-dropdown nav div {
  color: #FFF !important;
}
body[data-theme=dark] .MuiDrawer-paper div.select-org-dropdown nav div:hover {
  background: #4c4c4c !important;
}
body[data-theme=dark] .MuiDrawer-paper .MuiGrid-direction-xs-column {
  color: #f6f6f6;
}
body[data-theme=dark] .MuiDrawer-paper li svg path {
  fill: #fff;
}
body[data-theme=dark] .MuiDrawer-paper li > div.MuiListItemButton-root {
  color: #fff;
}
body[data-theme=dark] .MuiDrawer-paper li > div.MuiListItemButton-root:hover {
  color: #175CE5;
}
body[data-theme=dark] .MuiDrawer-paper li > div.MuiListItemButton-root:hover path {
  fill: #175CE5;
}
body[data-theme=dark] .MuiDrawer-paper li > div.domain-mgmt {
  color: #fff;
}
body[data-theme=dark] .MuiDrawer-paper li > div.domain-mgmt svg path {
  fill: none;
  stroke: #fff;
}
body[data-theme=dark] .MuiDrawer-paper li > div.domain-mgmt:hover {
  color: #175CE5;
}
body[data-theme=dark] .MuiDrawer-paper li > div.domain-mgmt:hover path {
  fill: none;
  stroke: #175CE5;
}
body[data-theme=dark] .MuiDrawer-paper li.selected > div {
  color: #175CE5;
}
body[data-theme=dark] .MuiDrawer-paper li.selected > div.domain-mgmt svg path {
  fill: none;
  stroke: #175CE5;
}
body[data-theme=dark] .MuiDrawer-paper li.selected svg path {
  fill: #175CE5;
}
body[data-theme=dark] label, body[data-theme=dark] p[data-testid=right-header] {
  color: #fff;
}
body[data-theme=dark] div.search-export-section .MuiInputBase-root {
  border: 1px solid rgba(226, 232, 240, 0.06);
  background: #1B1B1B;
  box-shadow: 1px 2px 6px 0px rgba(180, 191, 205, 0.06);
}
body[data-theme=dark] div.search-export-section .MuiInputBase-root input.MuiInputBase-input {
  color: #fff;
}
body[data-theme=dark] div.search-export-section .MuiInputBase-root input.MuiInputBase-input::placeholder {
  color: #8E92A0;
}
body[data-theme=dark] div.normal-border div.MuiOutlinedInput-root {
  background-color: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
body[data-theme=dark] div.normal-border div.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline,
body[data-theme=dark] div.normal-border div.MuiOutlinedInput-root .MuiOutlinedInput-root.Mui-focused fieldset {
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.normal-border div.MuiOutlinedInput-root:hover fieldset {
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.normal-border div.MuiOutlinedInput-root input.MuiInputBase-input {
  color: #fff;
}
body[data-theme=dark] div.normal-border div.MuiOutlinedInput-root input.MuiInputBase-input::placeholder {
  color: #8E92A0;
}
body[data-theme=dark] div.normal-border div.MuiOutlinedInput-root .MuiInputAdornment-positionEnd svg path {
  fill: #fff;
}
body[data-theme=dark] div.error-border div.MuiOutlinedInput-root {
  background-color: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
body[data-theme=dark] div.error-border div.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline,
body[data-theme=dark] div.error-border div.MuiOutlinedInput-root .MuiOutlinedInput-root.Mui-focused fieldset {
  border: 1px solid #F27A7A;
}
body[data-theme=dark] div.error-border div.MuiOutlinedInput-root:hover fieldset {
  border: 1px solid #F27A7A;
}
body[data-theme=dark] div.error-border div.MuiOutlinedInput-root input.MuiInputBase-input {
  color: #fff;
}
body[data-theme=dark] div.error-border div.MuiOutlinedInput-root input.MuiInputBase-input::placeholder {
  color: #8E92A0;
}
body[data-theme=dark] textarea {
  border: 1px solid var(--gray-800, #404040);
  background: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #fff;
}
body[data-theme=dark] textarea::placeholder {
  color: #8E92A0;
}
body[data-theme=dark] textarea:disabled {
  border: 1px solid var(--gray-800, #404040);
  background: #111;
}
body[data-theme=dark] div.search-input input.MuiInputBase-input {
  color: #fff;
}
body[data-theme=dark] div.search-input input.MuiInputBase-input::placeholder {
  color: #8E92A0;
}
body[data-theme=dark] div.search-input div.MuiOutlinedInput-root {
  border: 1px solid var(--gray-800, #404040);
  background-color: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
body[data-theme=dark] div.search-input .MuiInputAdornment-root svg {
  color: #fff;
}
body[data-theme=dark] div.input-select {
  background: #1B1B1B;
}
body[data-theme=dark] div.input-select-def-input {
  background: #1B1B1B;
}
body[data-theme=dark] div.input-select-def-input .MuiOutlinedInput-notchedOutline {
  border: 1px solid rgba(208, 213, 221, 0.1);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
body[data-theme=dark] div.input-select-def-input div.infoicon svg path {
  fill: #fff;
}
body[data-theme=dark] div.input-select-def-input .MuiSelect-outlined {
  color: #FFF;
}
body[data-theme=dark] div.input-select div.infoicon svg path {
  fill: #fff;
}
body[data-theme=dark] div.input-select .MuiSelect-outlined {
  color: #FFF;
}
body[data-theme=dark] div.input-radio label {
  color: #FFF !important;
}
body[data-theme=dark] input[type=date]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
body[data-theme=dark] div.input-number {
  background-color: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.input-number button svg path {
  fill: #fff;
}
body[data-theme=dark] div.input-number input.MuiNumberInput-input {
  color: #fff;
}
body[data-theme=dark] div.input-number input.MuiNumberInput-input::placeholder {
  color: #8E92A0;
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root,
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root {
  background-color: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  border: 1px solid var(--gray-800, #404040);
  border-right: none !important;
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-root,
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-root {
  background-color: #111;
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-notchedOutline,
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-right: none;
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root {
  color: var(--gray-500, #667085);
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiSvgIcon-root path {
  fill: #667085;
}
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root {
  color: #fff;
}
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiSvgIcon-root path {
  fill: #fff;
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root,
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root {
  background-color: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiOutlinedInput-root,
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiOutlinedInput-root {
  background-color: #111;
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiOutlinedInput-notchedOutline,
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--gray-800, #404040);
  border-left: none;
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root {
  color: var(--gray-500, #667085);
}
body[data-theme=dark] div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiSvgIcon-root path {
  fill: #667085;
}
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root {
  color: #fff;
}
body[data-theme=dark] div.phone-normal-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiSvgIcon-root path {
  fill: #fff;
}
body[data-theme=dark] div.phone-error-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root,
body[data-theme=dark] div.phone-error-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root {
  color: #fff;
  background-color: #111;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  border-right: none !important;
}
body[data-theme=dark] div.phone-error-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiSvgIcon-root path,
body[data-theme=dark] div.phone-error-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiSvgIcon-root path {
  fill: #fff;
}
body[data-theme=dark] div.phone-error-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-root,
body[data-theme=dark] div.phone-error-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-root {
  background-color: #111;
}
body[data-theme=dark] div.phone-error-input-disabled div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-notchedOutline,
body[data-theme=dark] div.phone-error-input div.MuiFormControl-root:nth-child(1) div.MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-right: none;
}
body[data-theme=dark] div.phone-error-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root {
  background-color: #111;
  color: var(--gray-500, #667085);
}
body[data-theme=dark] div.phone-error-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiOutlinedInput-root {
  background-color: #111;
}
body[data-theme=dark] div.phone-error-input-disabled div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiSvgIcon-root path {
  fill: #667085;
}
body[data-theme=dark] div.phone-error-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root {
  background-color: #111;
  color: #fff;
}
body[data-theme=dark] div.phone-error-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiOutlinedInput-root {
  background-color: #111;
}
body[data-theme=dark] div.phone-error-input div.MuiFormControl-root:nth-child(2) div.MuiInputBase-root .MuiSvgIcon-root path {
  fill: #fff;
}
body[data-theme=dark] .MuiAccordionSummary-root {
  background: #272727 !important;
  border-bottom: 1px solid rgba(240, 240, 240, 0.1);
}
body[data-theme=dark] .MuiAccordionSummary-root p {
  color: #fff;
}
body[data-theme=dark] .MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper svg {
  fill: #fff;
}
body[data-theme=dark] .MuiCollapse-root .accordion-body {
  border-bottom: 1px solid rgba(240, 240, 240, 0.1);
  background: var(--gray-800, #404040);
}
body[data-theme=dark] .MuiCollapse-root .accordion-body svg rect {
  fill: var(--gray-900, #242424);
}
body[data-theme=dark] .MuiCollapse-root .accordion-body svg path {
  fill: #404040;
}
body[data-theme=dark] .MuiCollapse-root .accordion-body .heading {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] .MuiCollapse-root .accordion-body .sub-heading {
  color: var(--gray-050, #FAFAFA);
}
body[data-theme=dark] .filter-btn {
  border: 1px solid rgba(226, 232, 240, 0.1) !important;
  background: #1B1B1B !important;
  box-shadow: 1px 2px 4px 0px rgba(180, 191, 205, 0.1) !important;
}
body[data-theme=dark] .filter-btn svg path {
  fill: white;
}
body[data-theme=dark] button[data-cy=export-btn], body[data-theme=dark] button.export-btn {
  background-color: #2F2F2F !important;
  color: var(--gray-1-white, #FFF) !important;
}
body[data-theme=dark] button[data-cy=export-btn] svg path, body[data-theme=dark] button.export-btn svg path {
  fill: #fff;
}
body[data-theme=dark] button[data-cy=export-btn]:hover, body[data-theme=dark] button.export-btn:hover {
  box-shadow: 0px 2px 12px 0px rgba(52, 52, 52, 0.46) !important;
}
body[data-theme=dark] button[data-cy=hover-btn] {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background-color: #2F2F2F !important;
  color: var(--gray-1-white, hsl(0, 0%, 100%));
}
body[data-theme=dark] button[data-cy=hover-btn] svg path {
  fill: #fff;
}
body[data-theme=dark] button[data-cy=hover-btn]:hover {
  border: 1px solid #175CE5;
  box-shadow: 0px 2px 12px 0px rgba(52, 52, 52, 0.46) !important;
  color: #175CE5;
}
body[data-theme=dark] button[data-cy=hover-btn]:hover svg path {
  fill: #175CE5;
}
body[data-theme=dark] button[data-cy=add-per-btn] {
  border: none;
}
body[data-theme=dark] button.left-arrow-btn {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background: #111;
  background-blend-mode: multiply;
}
body[data-theme=dark] button.left-arrow-btn svg path {
  fill: #fff;
}
body[data-theme=dark] button.left-arrow-btn:hover {
  background: var(--primary-600, #175CE5);
  color: #fff;
}
body[data-theme=dark] button.left-arrow-btn-reset {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background: #111;
  background-blend-mode: multiply;
}
body[data-theme=dark] button.left-arrow-btn-reset svg path {
  fill: #fff;
}
body[data-theme=dark] button.left-arrow-btn-reset:hover {
  background: #CC1F1F;
  color: #fff;
}
body[data-theme=dark] button[data-testid=tick-btn] {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background: #111;
  background-blend-mode: multiply;
}
body[data-theme=dark] button[data-testid=tick-btn] svg path {
  fill: #fff;
}
body[data-theme=dark] button[data-testid=tick-btn]:hover {
  background: var(--primary-600, #175CE5);
  color: #fff;
}
body[data-theme=dark] button.cross-btn, body[data-theme=dark] div.cross-btn {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background: #111;
  background-blend-mode: multiply;
}
body[data-theme=dark] button.cross-btn svg path, body[data-theme=dark] div.cross-btn svg path {
  fill: #fff;
}
body[data-theme=dark] button.cross-btn:hover, body[data-theme=dark] div.cross-btn:hover {
  background: var(--danger-600, #CC1F1F);
  color: #fff;
}
body[data-theme=dark] button.delete-btn {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background-color: #242424;
  background-blend-mode: multiply;
}
body[data-theme=dark] button.delete-btn:disabled svg path:nth-child(2) {
  fill: #5c5b5b;
}
body[data-theme=dark] button.delete-btn svg path:nth-child(2) {
  fill: #fff;
}
body[data-theme=dark] button.delete-btn:hover {
  background: var(--danger-600, #CC1F1F);
  color: #fff;
}
body[data-theme=dark] button[data-cy=add-admin-btn].def-btn {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background: #1B1B1B;
  color: var(--gray-1-white, #FFF);
}
body[data-theme=dark] button[data-cy=add-admin-btn].def-btn:hover {
  border: 1px solid #175CE5;
  color: #175CE5;
}
body[data-theme=dark] button[data-cy=add-admin-btn].add-btn, body[data-theme=dark] button[data-cy=add-admin-btn].remove-btn, body[data-theme=dark] button[data-testid=done-btn].export-btn, body[data-theme=dark] button.export-btn,
body[data-theme=dark] button[data-testid=promote-admin-btn] {
  border: none;
}
body[data-theme=dark] button[data-testid=remove-admin-btn] {
  border: none;
  background-color: #2F2F2F !important;
  color: var(--gray-1-white, #FFF) !important;
}
body[data-theme=dark] button[data-testid=remove-admin-btn]:hover {
  box-shadow: 0px 2px 12px 0px rgba(52, 52, 52, 0.46) !important;
}
body[data-theme=dark] div.upload-btn, body[data-theme=dark] button.upload-btn, body[data-theme=dark] button[data-cy=upload-btn] {
  border: 1px solid rgba(230, 230, 230, 0.1);
  background: #1B1B1B !important;
  color: var(--gray-1-white, #FFF);
}
body[data-theme=dark] div.upload-btn svg path, body[data-theme=dark] button.upload-btn svg path, body[data-theme=dark] button[data-cy=upload-btn] svg path {
  fill: #fff;
}
body[data-theme=dark] div.upload-btn p, body[data-theme=dark] button.upload-btn p, body[data-theme=dark] button[data-cy=upload-btn] p {
  color: var(--gray-1-white, #FFF);
}
body[data-theme=dark] div.upload-btn:hover, body[data-theme=dark] button.upload-btn:hover, body[data-theme=dark] button[data-cy=upload-btn]:hover {
  border: 1px solid #175CE5;
}
body[data-theme=dark] div.upload-btn:hover svg path, body[data-theme=dark] button.upload-btn:hover svg path, body[data-theme=dark] button[data-cy=upload-btn]:hover svg path {
  fill: #175CE5 !important;
}
body[data-theme=dark] div.upload-btn:hover p, body[data-theme=dark] button.upload-btn:hover p, body[data-theme=dark] button[data-cy=upload-btn]:hover p {
  color: var(--gray-1-white, #175CE5);
}
body[data-theme=dark] button.plus-btn {
  background-color: var(--btn-01-primary-enabled, #2469F3) !important;
}
body[data-theme=dark] button.create-tab-btn {
  border: 1px solid rgba(230, 230, 230, 0.1);
  color: var(--gray-1-white, #FFF);
}
body[data-theme=dark] button.create-tab-btn svg path {
  fill: #fff;
}
body[data-theme=dark] button.create-tab-btn p {
  color: var(--gray-1-white, #FFF);
}
body[data-theme=dark] button.create-tab-btn-selected {
  background: var(--btn-01-primary-enabled, #2469F3);
}
body[data-theme=dark] button.create-tab-btn-not-selected {
  background: #1B1B1B;
}
body[data-theme=dark] button.create-tab-btn-not-selected:hover {
  border: 1px solid #175CE5;
}
body[data-theme=dark] button.create-tab-btn-not-selected:hover svg path {
  fill: #175CE5 !important;
}
body[data-theme=dark] button.create-tab-btn-not-selected:hover p {
  color: var(--gray-1-white, #175CE5);
}
body[data-theme=dark] button.confirm-yes-btn {
  border: none;
}
body[data-theme=dark] button.confirm-no-btn {
  border: 1px solid rgba(208, 213, 221, 0.05);
  background: #2F2F2F;
  color: #fff;
}
body[data-theme=dark] button.confirm-no-btn:hover {
  border: 1px solid rgba(208, 213, 221, 0.05);
  background: #2F2F2F;
}
body[data-theme=dark] button.add-user-top-btns-org:hover {
  background-color: #171B2A !important;
  color: #3D79F2 !important;
}
body[data-theme=dark] button.add-user-top-btns-org:hover svg path {
  fill: #3D79F2;
}
body[data-theme=dark] button.add-user-top-btns-role:hover {
  background-color: #203723 !important;
  color: #1F992F !important;
}
body[data-theme=dark] button.add-user-top-btns-role:hover svg path {
  fill: #1F992F;
}
body[data-theme=dark] button.add-user-top-btns-group:hover {
  background-color: #251536 !important;
  color: #864CBF !important;
}
body[data-theme=dark] button.add-user-top-btns-group:hover svg path {
  fill: #864CBF;
}
body[data-theme=dark] div.users-list {
  background: var(--gray-900, #242424);
}
body[data-theme=dark] div.users-list div.user-div {
  background: var(--gray-900, #242424);
}
body[data-theme=dark] div.users-list-nill {
  background-color: transparent !important;
}
body[data-theme=dark] div.user-div {
  background: var(--gray-900, #242424);
}
body[data-theme=dark] div.list-user-white {
  background: #111 !important;
}
body[data-theme=dark] div.list-user-select {
  background: #292929 !important;
}
body[data-theme=dark] div.list-user-dark {
  background: var(--gray-900, #242424);
}
body[data-theme=dark] .MuiMenu-paper {
  border: 1px solid rgba(191, 191, 191, 0.1);
  background: #272727;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.15);
}
body[data-theme=dark] .MuiMenu-paper ul.MuiList-root li {
  color: #FFF;
}
body[data-theme=dark] .MuiMenu-paper ul.MuiList-root li svg path {
  fill: #fff;
}
body[data-theme=dark] .MuiMenu-paper ul.MuiList-root li:hover {
  background: #2F2F2F;
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableCell-head {
  background: #181818;
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableCell-head .MuiTableSortLabel-root svg path {
  fill: #fff;
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableCell-head .MuiTableSortLabel-root:hover {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root {
  border-bottom: 1px solid rgba(64, 64, 64, 0.5);
  background: #1B1B1B;
  box-shadow: none;
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root td {
  border-bottom: 1px solid rgba(64, 64, 64, 0.5);
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root td span.normal {
  color: var(--gray-white, #FFF) !important;
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root td div.app-type {
  color: #14b2b2;
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root:hover {
  background-color: #101010;
}
body[data-theme=dark] .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root.Mui-selected {
  background-color: #292929;
}
body[data-theme=dark] div[data-testid=left-panel],
body[data-theme=dark] div[data-testid=blank-panel],
body[data-theme=dark] div[data-testid=dom-admin-left-panel],
body[data-theme=dark] div[data-testid=right-panel],
body[data-theme=dark] div[data-testid=right-panel] > div.blank-panel,
body[data-theme=dark] div[data-testid=adv-api-mgmt],
body[data-theme=dark] div[data-testid=app-blank-panel],
body[data-theme=dark] div[data-testid=prev-right-panel],
body[data-theme=dark] div[data-testid=main-auth-container],
body[data-theme=dark] div[data-testid=create-users-blank-panel],
body[data-theme=dark] div[data-testid=domadmin-left-panel-header] {
  background-color: #1B1B1B;
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] div[data-testid=right-panel] > div.blank-panel svg path, body[data-theme=dark] div[data-testid=blank-panel] svg path, body[data-theme=dark] div[data-testid=create-users-blank-panel] svg path {
  fill: #fff;
}
body[data-theme=dark] div[data-testid=right-panel] > div.blank-panel p, body[data-theme=dark] div[data-testid=blank-panel] p, body[data-theme=dark] div[data-testid=create-users-blank-panel] p {
  color: #fff;
}
body[data-theme=dark] div[data-testid=domadmin-left-panel-header] p {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] p[data-testid=left-panel-title], body[data-theme=dark] .list-count {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] div.chip-active {
  background-color: #193C1E;
}
body[data-theme=dark] div.chip-active span {
  color: #B0FFC3;
}
body[data-theme=dark] div.chip-inactive {
  background-color: #4D3234;
}
body[data-theme=dark] div.chip-inactive span {
  color: #FF7296;
}
body[data-theme=dark] div.chip {
  background-color: #242424;
}
body[data-theme=dark] div.chip-unlock {
  color: #fff;
}
body[data-theme=dark] div.chip-unlock svg path {
  fill: #fff;
}
body[data-theme=dark] div.chips-Organizations {
  background: #171B2A;
}
body[data-theme=dark] div.chips-Organizations .MuiChip-label {
  color: var(--Main, #5D5FEF);
}
body[data-theme=dark] div.chips-Roles {
  background: #203723;
}
body[data-theme=dark] div.chips-Roles .MuiChip-label {
  color: var(--success-600, #24B237);
}
body[data-theme=dark] div.chips-Groups {
  background: #251536;
}
body[data-theme=dark] div.chips-Groups .MuiChip-label {
  color: var(--secondary-600, #6B24B2);
}
body[data-theme=dark] div.chips-trans .MuiChip-label {
  color: #fff;
}
body[data-theme=dark] div.custom-pagination {
  background-color: #252525 !important;
}
body[data-theme=dark] div.custom-pagination .MuiTablePagination-selectLabel, body[data-theme=dark] div.custom-pagination .MuiTablePagination-displayedRows {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] div.custom-pagination .MuiTablePagination-select {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] div.custom-pagination .MuiTablePagination-select:focus {
  background-color: #252525 !important;
}
body[data-theme=dark] div.custom-pagination .MuiTablePagination-selectIcon {
  fill: #fff;
}
body[data-theme=dark] div.custom-pagination button[aria-label="previous page"], body[data-theme=dark] div.custom-pagination button[aria-label="next page"] {
  border: 1px solid rgba(226, 232, 240, 0.12);
  background: #1B1B1B;
}
body[data-theme=dark] div.custom-pagination button[aria-label="previous page"]:disabled, body[data-theme=dark] div.custom-pagination button[aria-label="next page"]:disabled {
  color: #505B69;
}
body[data-theme=dark] div.custom-pagination button[aria-label="previous page"]:disabled svg path, body[data-theme=dark] div.custom-pagination button[aria-label="next page"]:disabled svg path {
  stroke: #505B69;
}
body[data-theme=dark] div.custom-pagination button[aria-label="previous page"]:hover, body[data-theme=dark] div.custom-pagination button[aria-label="next page"]:hover {
  background: #1f1f1f;
}
body[data-theme=dark] .MuiSwitch-track {
  background-color: #404040;
}
body[data-theme=dark] .MuiSwitch-thumb {
  background-color: #242424;
}
body[data-theme=dark] .empty-list {
  background-color: #242424;
}
body[data-theme=dark] .empty-list p {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] .app-type {
  color: #14b2b2;
}
body[data-theme=dark] .app-type .MuiChip-label {
  color: #14b2b2;
}
body[data-theme=dark] .org-badge {
  background: #171B2A;
}
body[data-theme=dark] .org-badge .MuiChip-label {
  color: var(--Main, #5D5FEF);
}
body[data-theme=dark] .role-badge {
  background: #203723;
}
body[data-theme=dark] .role-badge .MuiChip-label {
  color: var(--success-600, #24B237);
}
body[data-theme=dark] .group-badge {
  background: #251536;
}
body[data-theme=dark] .group-badge .MuiChip-label {
  color: var(--secondary-600, #6B24B2);
}
body[data-theme=dark] .popup-container {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: #161616;
}
body[data-theme=dark] .popup-container .create-form-container {
  border: 1px solid rgba(230, 230, 230, 0.1);
}
body[data-theme=dark] .view-users-popup {
  background: #111;
}
body[data-theme=dark] .view-users-popup .MuiPaper-rounded {
  background: #111;
}
body[data-theme=dark] .view-users-popup .MuiTableRow-head {
  background: #111;
}
body[data-theme=dark] .view-users-popup .MuiTableBody-root .MuiTableRow-root td {
  border-bottom: none !important;
}
body[data-theme=dark] .view-users-popup button.view-edit-btn svg {
  color: #fff;
}
body[data-theme=dark] .group-filter-popup > div {
  background: #111 !important;
}
body[data-theme=dark] .group-filter-popup > div .filter-header svg path {
  fill: #fff;
}
body[data-theme=dark] .group-filter-popup > div .filter-header p {
  color: #fff !important;
}
body[data-theme=dark] .group-filter-popup > div button.left-btn, body[data-theme=dark] .group-filter-popup > div button.right-btn {
  border: 1px solid rgba(226, 232, 240, 0.1);
  background: #111;
  box-shadow: none;
}
body[data-theme=dark] .group-filter-popup > div button.left-btn svg path, body[data-theme=dark] .group-filter-popup > div button.right-btn svg path {
  stroke: white;
}
body[data-theme=dark] .confirm-popup-container {
  border-radius: 16px;
  border: 1px solid rgba(255, 253, 253, 0.5);
  background: #1B1B1B;
}
body[data-theme=dark] .confirm-popup-container p {
  color: #fff;
}
body[data-theme=dark] .confirm-popup-container .create-form-container {
  border: 1px solid rgba(230, 230, 230, 0.1);
}
body[data-theme=dark] button.edit-btn {
  border: 1px solid rgba(208, 213, 221, 0.1);
  background-color: #242424;
  background-blend-mode: multiply;
}
body[data-theme=dark] button.edit-btn svg {
  color: #fff !important;
}
body[data-theme=dark] button.edit-btn:hover {
  background-color: #2469F3;
}
body[data-theme=dark] div.upload-main-heading svg path {
  fill: #fff;
}
body[data-theme=dark] div.upload-main-heading p {
  color: #fff;
}
body[data-theme=dark] div[data-testid=main-auth-container] > p {
  color: #fff;
}
body[data-theme=dark] div[data-testid=main-auth-container] div.auth-containers {
  background: #111 !important;
  border: 1px solid rgba(226, 232, 240, 0.1);
}
body[data-theme=dark] div[data-testid=main-auth-container] div.auth-containers > p {
  color: #fff;
}
body[data-theme=dark] div[data-testid=main-auth-container] div.auth-containers div.option-box {
  border: 1px solid rgba(226, 232, 240, 0.1);
}
body[data-theme=dark] div.main-side-drawer {
  background: #111 !important;
}
body[data-theme=dark] div.main-side-drawer .drawer-header {
  background: #111 !important;
}
body[data-theme=dark] div.main-side-drawer .time-updates {
  background-color: #111;
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.main-side-drawer .time-updates svg path {
  fill: #fff;
}
body[data-theme=dark] div.main-side-drawer .time-updates p {
  color: #fff !important;
}
body[data-theme=dark] div.main-side-drawer .input-policy {
  background-color: #111;
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.main-side-drawer .tags {
  background-color: #111;
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.main-side-drawer .tags input {
  background-color: #111 !important;
  color: #fff !important;
}
body[data-theme=dark] div.main-side-drawer .tags input::placeholder {
  color: #8E92A0;
}
body[data-theme=dark] div.main-side-drawer .res-table-header {
  background: #181818;
}
body[data-theme=dark] div.main-side-drawer .res-table-row {
  border-bottom: 1px solid rgba(64, 64, 64, 0.5);
  background: #1B1B1B;
  box-shadow: none;
}
body[data-theme=dark] .subscr-div {
  background-color: transparent;
}
body[data-theme=dark] .subscr-div-list {
  background: var(--gray-900, #242424);
}
body[data-theme=dark] .subscr-div-list .delete-app svg {
  color: #fff;
}
body[data-theme=dark] .subscr-div-list .delete-app:hover svg {
  color: #CC1F1F;
}
body[data-theme=dark] .toggle-tabs {
  background: #2F2F2F;
}
body[data-theme=dark] .toggle-tabs .MuiToggleButton-root {
  background: #2F2F2F;
}
body[data-theme=dark] .toggle-tabs .MuiToggleButton-root span {
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] .toggle-tabs .MuiBadge-root .MuiBadge-badge svg path {
  fill: #fff;
}
body[data-theme=dark] .main-portal-tabs {
  background: #2F2F2F;
}
body[data-theme=dark] .main-portal-tabs div.not-select svg path {
  fill: #fff;
}
body[data-theme=dark] .main-portal-tabs div.not-select p {
  color: #fff;
}
body[data-theme=dark] div.normal-card {
  background: var(--gray-900, #242424);
}
body[data-theme=dark] div.normal-card:hover {
  background: var(--primary-050, #E0E9FA);
}
body[data-theme=dark] div.normal-card:hover p.list-count {
  color: var(--gray-900, #101828);
}
body[data-theme=dark] div.normal-card:hover p.created-by, body[data-theme=dark] div.normal-card:hover p.card-details {
  color: var(--primary-900, #051433);
}
body[data-theme=dark] div.normal-card:hover svg.delete-icon {
  color: #242424;
}
body[data-theme=dark] div.select-card p.list-count {
  color: var(--gray-900, #101828);
}
body[data-theme=dark] div.select-card p.created-by, body[data-theme=dark] div.select-card p.card-details {
  color: var(--primary-900, #051433);
}
body[data-theme=dark] div.select-card svg.delete-icon {
  color: #242424;
}
body[data-theme=dark] div.side-drawer-tabs {
  border-bottom: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.side-drawer-tabs .Mui-selected.MuiToggleButton-root {
  background-color: transparent;
}
body[data-theme=dark] div.label-with-chips {
  background-color: #111;
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.user-reset-pwd {
  background-color: #111;
}
body[data-theme=dark] div.create-form-wrapper {
  background-color: #1B1B1B;
}
body[data-theme=dark] div.create-form-wrapper .radio-btn-wrapper {
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.caption-box {
  background-color: transparent;
  color: #fff;
}
body[data-theme=dark] .border-dark {
  border: 1px solid var(--gray-800, #404040) !important;
}
body[data-theme=dark] div.quick-app-container {
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.quick-app-container svg path {
  fill: #fff;
}
body[data-theme=dark] div.MuiPopover-paper {
  background: #272727 !important;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.15) !important;
}
body[data-theme=dark] div.MuiPopover-paper nav div:nth-child(1) svg path {
  fill: #fff;
}
body[data-theme=dark] div.MuiPopover-paper nav div:hover {
  background: #4c4c4c !important;
}
body[data-theme=dark] div.choose-wrapper {
  background-color: #1B1B1B;
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] .mid-container {
  background: #111;
  border: 1px solid rgba(230, 230, 230, 0.1);
}
body[data-theme=dark] div.blank-panel {
  background-color: #1B1B1B;
  color: var(--gray-white, #FFF);
}
body[data-theme=dark] div.blank-panel svg path {
  fill: #fff;
}
body[data-theme=dark] div.blank-panel p {
  color: #fff;
}
body[data-theme=dark] .dark-bg {
  background-color: #1B1B1B !important;
}
body[data-theme=dark] .dark-with-border {
  background-color: #1B1B1B !important;
  border: 1px solid rgba(230, 230, 230, 0.1) !important;
}
body[data-theme=dark] button.button-wrapper:disabled {
  color: #505B69;
  border: 1px solid rgba(230, 230, 230, 0.1);
}
body[data-theme=dark] .dark-skeleton {
  background-image: linear-gradient(90deg, #333 0%, #666 50%, #333 100%);
}
body[data-theme=dark] .central-items {
  background-color: #111 !important;
}
body[data-theme=dark] .light-dark {
  background: #504e4e !important;
}
body[data-theme=dark] .graph-border {
  border-bottom: 1px solid rgba(230, 230, 230, 0.1);
}
body[data-theme=dark] div[data-testid=toast-message] {
  background-color: #1B1B1B !important;
}
body[data-theme=dark] div[data-testid=toast-message] p[data-testid=toast-heading] {
  color: #fff !important;
}
body[data-theme=dark] div[data-testid=toast-message] p[data-testid=toast-description] {
  color: #adbbd0 !important;
}
body[data-theme=dark] div[data-testid=toast-message] svg.copy-icon path, body[data-theme=dark] div[data-testid=toast-message] svg.cross-icon path {
  fill: #fff;
}
body[data-theme=dark] div.feature-counts-box, body[data-theme=dark] div.pie-chart-card,
body[data-theme=dark] div.stats-widget, body[data-theme=dark] div.graph-main-widget,
body[data-theme=dark] div.aside-panel {
  background: #1B1B1B;
}
body[data-theme=dark] div.central-items-content {
  background: var(--gray-900, #242424) !important;
}
body[data-theme=dark] div.api-app-analytics svg path {
  fill: #fff;
}
body[data-theme=dark] .light-color {
  color: var(--gray-400, #C2C2C2);
}
body[data-theme=dark] div.analytics-cards {
  border: 0.546px solid var(--gray-800, #404040);
  background: var(--gray-900, #242424);
  box-shadow: 0px 0.546px 1.639px 0px rgba(0, 81, 175, 0.1);
}
body[data-theme=dark] div.duration-tabs {
  border: 1px solid var(--gray-800, #404040);
}
body[data-theme=dark] div.duration-tabs div.single-tab-selected {
  background: var(--gray-200, #F0F0F0);
}
body[data-theme=dark] div.duration-tabs div.single-tab-not-selected {
  border-right: 1px solid var(--gray-800, #404040);
  background: var(--gray-900, #242424);
  box-shadow: none;
  color: #fff;
}
body[data-theme=dark] div.duration-tabs div.single-tab-not-selected svg path {
  fill: #fff;
}
body[data-theme=dark] div.pill-tabs {
  background: rgba(233, 235, 253, 0.1);
}
body[data-theme=dark] div.pill-tabs div.single-tab-not-selected {
  color: #fff;
}
body[data-theme=dark] button.dashboard-refresh {
  border: 1px solid rgba(208, 213, 221, 0.1);
}
body[data-theme=dark] button.dashboard-refresh svg path {
  fill: #fff;
}
body[data-theme=dark] div.progress-mgmt {
  border-bottom: 1px solid var(--gray-800, #404040);
}`, "",{"version":3,"sources":["webpack://./src/globals.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AAAF;;AAGA;;EAEE,UAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;AAAF;;AAGA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,qCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,0CAAA;EACA,gBAAA;AAAF;;AAOA;EACE,aAAA;AAJF;AAKE;EACE,iDAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,aAAA;AAJF;AAKE;EACE,+CAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,uBAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,yDAAA;EACA,4BAAA;EACA,4BAAA;AAJF;;AAMA;EACE,yDAAA;EACA,4BAAA;EACA,4BAAA;AAHF;;AAKA;EACE,yDAAA;EACA,4BAAA;EACA,4BAAA;AAFF;;AAIA;EACE,2BAAA;AADF;;AAGA;EACE,2BAAA;AAAF;;AAEC;EACC,aAAA;AACF;;AAEA;EACE,wBAAA;EACA,2BAAA;AACF;;AAEA;EACE,qBAAA;EACA,kCAAA;AACF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE;IACE,uBAAA;EAAF;EAEA;IACE,yBAAA;EAAF;AACF;AAKI;EACE,WAAA;AAHN;;AAQA;EACE,wBAAA;AALF;;AAcA;EACE,yCAAA;AAXF;;AAcA;EACE;;IAEE,SAAA;EAXF;AACF;AAcA;EACE;IACE,0BAAA;EAZF;AACF;AAeA;EACE;IACE,0BAAA;EAbF;EAeA;IACE,0BAAA;EAbF;AACF;AAgBA;EACE;;IAKE,iBAAA;EAjBF;EAcE;;IACE,0BAAA;EAXJ;AACF;AAgBA;EAEI;IACE,2BAAA;EAfJ;AACF;AAmBA;EACE;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;EAjBF;AACF;AAoBA;EACE;;;;IAIE,oBAAA;EAlBF;EAmBE;;;;IACE,UAAA;EAdJ;AACF;AAkBA;EAEI;IACE,0BAAA;EAjBJ;EAmBE;IACE,2BAAA;EAjBJ;EAoBA;;IAEE,SAAA;EAlBF;EAmBE;;;;IACE,0BAAA;EAdJ;EAiBA;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;EAfF;EAiBA;IACE,kBAAA;IACA,gBAAA;EAfF;EAgBE;IACE,0BAAA;EAdJ;EAkBE;IACE,SAAA;EAhBJ;EAiBI;IACE,YAAA;EAfN;EAkBE;IACE,0BAAA;EAhBJ;EAmBA;;;;IAIE,cAAA;EAjBF;EAoBE;IACE,SAAA;EAlBJ;EAmBI;IACE,YAAA;EAjBN;EAmBI;IACE,0BAAA;EAjBN;EAmBI;;;IAGE,2BAAA;EAjBN;EAmBI;IACE,2BAAA;EAjBN;EAkBM;IACE,yBAAA;EAhBR;EAmBI;;IAEE,+BAAA;EAjBN;EAmBI;;IAEE,+BAAA;EAjBN;EAmBI;;IAEE,+BAAA;EAjBN;EAkBM;;IACE,uBAAA;IACA,eAAA;EAfR;EAkBI;IACE,YAAA;EAhBN;EAiBM;IACE,YAAA;EAfR;EAmBM;IACE,uBAAA;EAjBR;EAmBM;IACE,uBAAA;IACA,sBAAA;EAjBR;EAmBM;IACE,uBAAA;IACA,eAAA;EAjBR;EAqBM;;;IAGE,uBAAA;IACA,eAAA;EAnBR;EAsBI;IACE,uBAAA;EApBN;EAsBI;;;;IAIE,SAAA;EApBN;EAqBM;;;;IACE,YAAA;EAhBR;EAiBQ;;;;IACE,gBAAA;EAZV;EAaU;;;;;;;;;;;;IAEE,uBAAA;IACA,eAAA;IACA,0BAAA;EADZ;EAMQ;;;;IACE,aAAA;EADV;EAMM;;;;IAIE,WAAA;IACA,YAAA;IACA,aAAA;EAJR;EAUE;IACE,YAAA;EARJ;EAWA;IACE,uCAAA;EATF;EAWA;IACE,+BAAA;EATF;EAWA;IACE,YAAA;EATF;EAWI;IACE,eAAA;EATN;EAYE;IACE,uBAAA;EAVJ;EAcE;IACE,uBAAA;EAZJ;EAeA;IACE,2BAAA;IACA,cAAA;EAbF;EAeA;IACE,sCAAA;EAbF;EAeA;IACE,2BAAA;IACA,cAAA;EAbF;EAeA;IACE,4BAAA;EAbF;EAeA;IACE,sCAAA;EAbF;EAeA;IACE,sCAAA;EAbF;EAeA;;;;;IAKE,+BAAA;IACA,+BAAA;EAbF;EAeA;IACE,sCAAA;EAbF;EAeA;IACE,QAAA;EAbF;EAeA;IACE,YAAA;EAbF;EAeA;IACE,+BAAA;EAbF;EAeA;IACE,2BAAA;EAbF;EAeA;IACE,2BAAA;EAbF;EAiBI;IACE,YAAA;EAfN;EAoBE;IACE,4BAAA;EAlBJ;EAoBE;;IAEE,0BAAA;EAlBJ;EAoBE;IACE,6BAAA;EAlBJ;EAoBE;IACE,4BAAA;EAlBJ;EAmBI;IACE,4BAAA;EAjBN;AACF;AAuBE;EACE,gBAAA;AArBJ;AAuBE;EACE,gBAAA;EACA,WAAA;AArBJ;AAuBE;EACE,UAAA;AArBJ;AAyBM;EACE,aAAA;AAvBR;AA4BE;EACE,yBAAA;AA1BJ;AA4BM;EACE,8BAAA;AA1BR;AA4BM;EACE,6BAAA;AA1BR;AA6BI;EACE,YAAA;EACA,mBAAA;AA3BN;AA4BM;EACE,+BAAA;AA1BR;AA4BM;EACE,WAAA;AA1BR;AA6BI;EACE,+CAAA;AA3BN;AA4BM;EACE,mBAAA;AA1BR;AA+BE;EACE,yBAAA;AA7BJ;AA8BI;EACE,8BAAA;EACA,4DAAA;AA5BN;AA6BM;EACE,sBAAA;AA3BR;AA4BQ;EACE,8BAAA;AA1BV;AA8BI;EACE,cAAA;AA5BN;AA+BM;EACE,UAAA;AA7BR;AA+BM;EACE,WAAA;AA7BR;AA8BQ;EACE,cAAA;AA5BV;AA6BU;EACE,aAAA;AA3BZ;AA+BM;EACE,WAAA;AA7BR;AA8BQ;EACE,UAAA;EACA,YAAA;AA5BV;AA8BQ;EACE,cAAA;AA5BV;AA6BU;EACE,UAAA;EACA,eAAA;AA3BZ;AAiCM;EACE,cAAA;AA/BR;AAkCQ;EACE,UAAA;EACA,eAAA;AAhCV;AAmCM;EACE,aAAA;AAjCR;AAsCE;EACE,WAAA;AApCJ;AAuCI;EACE,2CAAA;EACA,mBAAA;EACA,qDAAA;AArCN;AAsCM;EACE,WAAA;AApCR;AAqCQ;EACE,cAAA;AAnCV;AA0CI;EACE,sBAAA;EACA,kDAAA;AAxCN;AAyCM;;EAEE,0CAAA;AAvCR;AA0CQ;EACE,0CAAA;AAxCV;AA2CM;EACE,WAAA;AAzCR;AA0CQ;EACE,cAAA;AAxCV;AA4CQ;EACE,UAAA;AA1CV;AAgDI;EACE,sBAAA;EACA,kDAAA;AA9CN;AA+CM;;EAEE,yBAAA;AA7CR;AAgDQ;EACE,yBAAA;AA9CV;AAiDM;EACE,WAAA;AA/CR;AAgDQ;EACE,cAAA;AA9CV;AAmDE;EACE,0CAAA;EACA,gBAAA;EACA,kDAAA;EACA,WAAA;AAjDJ;AAkDI;EACE,cAAA;AAhDN;AAkDI;EACE,0CAAA;EACA,gBAAA;AAhDN;AAqDI;EACE,WAAA;AAnDN;AAoDM;EACE,cAAA;AAlDR;AAqDI;EACE,0CAAA;EACA,sBAAA;EACA,kDAAA;AAnDN;AAsDM;EACE,WAAA;AApDR;AAyDE;EACE,mBAAA;AAvDJ;AA2DI;EACE,mBAAA;AAzDN;AA0DM;EACE,0CAAA;EAEA,kDAAA;AAzDR;AA+DQ;EACE,UAAA;AA7DV;AAgEM;EACE,WAAA;AA9DR;AAkEM;EACE,UAAA;AAhER;AAmEI;EACE,WAAA;AAjEN;AAsEI;EACE,sBAAA;AApEN;AAwEE;EACE,iBAAA;AAtEJ;AAyEE;EACE,sBAAA;EACA,kDAAA;EACA,0CAAA;AAvEJ;AAyEM;EACE,UAAA;AAvER;AA0EI;EACE,WAAA;AAxEN;AAyEM;EACE,cAAA;AAvER;AA8EI;;EAIE,sBAAA;EACA,kDAAA;EACA,0CAAA;EACA,6BAAA;AA9EN;AAwEM;;EACE,sBAAA;AArER;AA2EM;;EACE,kBAAA;AAxER;AA6EM;EACE,+BAAA;AA3ER;AA6EU;EACE,aAAA;AA3EZ;AAiFI;EACA,WAAA;AA/EJ;AAiFM;EACE,UAAA;AA/ER;AAsFE;;EAIE,sBAAA;EACA,kDAAA;AAtFJ;AAkFI;;EACE,sBAAA;AA/EN;AAmFI;;EACE,0CAAA;EACA,iBAAA;AAhFN;AAqFI;EACE,+BAAA;AAnFN;AAqFQ;EACE,aAAA;AAnFV;AAyFE;EACA,WAAA;AAvFF;AAyFI;EACE,UAAA;AAvFN;AA+FI;;EACE,WAAA;EASA,sBAAA;EACA,kDAAA;EAEA,6BAAA;AArGN;AA2FQ;;EACE,UAAA;AAxFV;AA2FM;;EACE,sBAAA;AAxFR;AA8FM;;EACE,kBAAA;AA3FR;AAgGI;EACE,sBAAA;EAIA,+BAAA;AAjGN;AA8FM;EACE,sBAAA;AA5FR;AAgGQ;EACE,aAAA;AA9FV;AAoGE;EACE,sBAAA;EAIF,WAAA;AArGF;AAkGI;EACE,sBAAA;AAhGN;AAoGI;EACE,UAAA;AAlGN;AAwGE;EACE,8BAAA;EAIA,iDAAA;AAzGJ;AAsGI;EACE,WAAA;AApGN;AAwGM;EACE,UAAA;AAtGR;AA2GI;EACE,iDAAA;EACA,oCAAA;AAzGN;AA2GQ;EACE,8BAAA;AAzGV;AA2GQ;EACE,aAAA;AAzGV;AA4GM;EACE,8BAAA;AA1GR;AA4GM;EACE,+BAAA;AA1GR;AAgHE;EACE,qDAAA;EACA,8BAAA;EACA,+DAAA;AA9GJ;AA+GI;EACE,WAAA;AA7GN;AAiHE;EACE,oCAAA;EACA,2CAAA;AA/GJ;AAgHI;EACE,UAAA;AA9GN;AAgHI;EACE,8DAAA;AA9GN;AAkHE;EACE,0CAAA;EACA,oCAAA;EACA,4CAAA;AAhHJ;AAiHI;EACE,UAAA;AA/GN;AAiHI;EACE,yBAAA;EAIA,8DAAA;EACA,cAAA;AAlHN;AA8GM;EACE,aAAA;AA5GR;AAmHE;EACE,YAAA;AAjHJ;AAoHE;EACE,0CAAA;EACA,gBAAA;EACA,+BAAA;AAlHJ;AAmHI;EACE,UAAA;AAjHN;AAmHI;EACE,uCAAA;EACA,WAAA;AAjHN;AAmHI;EACE,0CAAA;EACA,gBAAA;EACA,+BAAA;AAjHN;AAkHM;EACE,UAAA;AAhHR;AAkHM;EACE,mBAAA;EACA,WAAA;AAhHR;AAqHE;EACE,0CAAA;EACA,gBAAA;EACA,+BAAA;AAnHJ;AAoHI;EACE,UAAA;AAlHN;AAoHI;EACE,uCAAA;EACA,WAAA;AAlHN;AAsHE;EACE,0CAAA;EACA,gBAAA;EACA,+BAAA;AApHJ;AAqHI;EACE,UAAA;AAnHN;AAqHI;EACE,sCAAA;EACA,WAAA;AAnHN;AAsHE;EAME,0CAAA;EACA,yBAAA;EACA,+BAAA;AAzHJ;AAmHM;EACE,aAAA;AAjHR;AAuHI;EACE,UAAA;AArHN;AAuHI;EACE,sCAAA;EACA,WAAA;AArHN;AAyHE;EACE,0CAAA;EACA,mBAAA;EACA,gCAAA;AAvHJ;AAwHI;EACE,yBAAA;EACA,cAAA;AAtHN;AAyHE;;EAEE,YAAA;AAvHJ;AA0HE;EACE,YAAA;EACA,oCAAA;EACA,2CAAA;AAxHJ;AAyHI;EACE,8DAAA;AAvHN;AA2HE;EACE,0CAAA;EACA,8BAAA;EACA,gCAAA;AAzHJ;AA0HI;EACE,UAAA;AAxHN;AA0HI;EACE,gCAAA;AAxHN;AA0HI;EACE,yBAAA;AAxHN;AAyHM;EACE,wBAAA;AAvHR;AAyHM;EACE,mCAAA;AAvHR;AA4HE;EACE,mEAAA;AA1HJ;AA6HE;EACE,0CAAA;EACA,gCAAA;AA3HJ;AA4HI;EACE,UAAA;AA1HN;AA4HI;EACE,gCAAA;AA1HN;AA4HI;EACE,kDAAA;AA1HN;AA4HI;EACE,mBAAA;AA1HN;AA2HM;EACE,yBAAA;AAzHR;AA0HQ;EACE,wBAAA;AAxHV;AA0HQ;EACE,mCAAA;AAxHV;AA+HI;EACE,YAAA;AA7HN;AA+HI;EACE,2CAAA;EACA,mBAAA;EACA,WAAA;AA7HN;AA8HM;EACE,2CAAA;EACA,mBAAA;AA5HR;AAmIQ;EACE,oCAAA;EACA,yBAAA;AAjIV;AAkIU;EACE,aAAA;AAhIZ;AAqIQ;EACE,oCAAA;EACA,yBAAA;AAnIV;AAoIU;EACE,aAAA;AAlIZ;AAuIQ;EACE,oCAAA;EACA,yBAAA;AArIV;AAsIU;EACE,aAAA;AApIZ;AA0IE;EACE,oCAAA;AAxIJ;AAyII;EACE,oCAAA;AAvIN;AA0IE;EACE,wCAAA;AAxIJ;AA0IE;EACE,oCAAA;AAxIJ;AA2II;EACE,2BAAA;AAzIN;AA2II;EACE,8BAAA;AAzIN;AA2II;EACE,oCAAA;AAzIN;AA4IE;EACE,0CAAA;EACA,mBAAA;EACA,iDAAA;AA1IJ;AA4IM;EACE,WAAA;AA1IR;AA2IQ;EACE,UAAA;AAzIV;AA2IQ;EACE,mBAAA;AAzIV;AAiJQ;EACE,mBAAA;EACA,8BAAA;AA/IV;AAiJY;EACE,UAAA;AA/Id;AAiJY;EACE,8BAAA;AA/Id;AAqJQ;EACE,8CAAA;EACA,mBAAA;EACA,gBAAA;AAnJV;AAoJU;EACE,8CAAA;EACA,8BAAA;AAlJZ;AAmJY;EACE,yCAAA;AAjJd;AAmJY;EACE,cAAA;AAjJd;AAoJU;EACE,yBAAA;AAlJZ;AAoJU;EACE,yBAAA;AAlJZ;AAyJE;;;;;;;;;;;EAWE,yBAAA;EACA,8BAAA;AAvJJ;AA0JI;EACE,UAAA;AAxJN;AA0JI;EACE,WAAA;AAxJN;AA4JI;EACE,8BAAA;AA1JN;AA6JE;EACE,8BAAA;AA3JJ;AA6JE;EACE,yBAAA;AA3JJ;AA4JI;EACE,cAAA;AA1JN;AA6JE;EACE,yBAAA;AA3JJ;AA4JI;EACE,cAAA;AA1JN;AA6JE;EACE,yBAAA;AA3JJ;AA8JI;EACE,WAAA;AA5JN;AA6JM;EACE,UAAA;AA3JR;AAgKI;EACE,mBAAA;AA9JN;AA+JM;EACE,2BAAA;AA7JR;AAgKI;EACE,mBAAA;AA9JN;AA+JM;EACE,kCAAA;AA7JR;AAgKI;EACE,mBAAA;AA9JN;AA+JM;EACE,oCAAA;AA7JR;AAiKM;EACE,WAAA;AA/JR;AAoKE;EACE,oCAAA;AAlKJ;AAmKI;EACE,8BAAA;AAjKN;AAmKI;EACE,8BAAA;AAjKN;AAkKM;EACE,oCAAA;AAhKR;AAmKI;EACE,UAAA;AAjKN;AAmKI;EACE,2CAAA;EACA,mBAAA;AAjKN;AAkKM;EACE,cAAA;AAhKR;AAiKQ;EACE,eAAA;AA/JV;AAkKM;EACE,mBAAA;AAhKR;AAqKE;EACE,yBAAA;AAnKJ;AAqKE;EACE,yBAAA;AAnKJ;AAqKE;EACE,yBAAA;AAnKJ;AAoKI;EACE,8BAAA;AAlKN;AAqKE;EACE,cAAA;AAnKJ;AAoKI;EACE,cAAA;AAlKN;AAqKE;EACE,mBAAA;AAnKJ;AAoKI;EACE,2BAAA;AAlKN;AAqKE;EACE,mBAAA;AAnKJ;AAoKI;EACE,kCAAA;AAlKN;AAqKE;EACE,mBAAA;AAnKJ;AAoKI;EACE,oCAAA;AAlKN;AAqKE;EACE,mBAAA;EACA,0CAAA;EACA,mBAAA;AAnKJ;AAoKI;EACE,0CAAA;AAlKN;AAqKE;EACE,gBAAA;AAnKJ;AAoKI;EACE,gBAAA;AAlKN;AAoKI;EACE,gBAAA;AAlKN;AAoKI;EACE,8BAAA;AAlKN;AAqKM;EACE,WAAA;AAnKR;AAuKE;EACE,2BAAA;AArKJ;AAuKM;EACE,UAAA;AArKR;AAuKM;EACE,sBAAA;AArKR;AAwKI;EACE,0CAAA;EACA,gBAAA;EACA,gBAAA;AAtKN;AAuKM;EACE,aAAA;AArKR;AAyKE;EACE,mBAAA;EACA,0CAAA;EACA,mBAAA;AAvKJ;AAwKI;EACE,WAAA;AAtKN;AAwKI;EACE,0CAAA;AAtKN;AAyKE;EACE,0CAAA;EACA,yBAAA;EACA,+BAAA;AAvKJ;AAwKI;EACE,sBAAA;AAtKN;AAwKI;EACE,yBAAA;AAtKN;AA0KI;EACE,UAAA;AAxKN;AA0KI;EACE,WAAA;AAxKN;AA4KI;EACE,WAAA;AA1KN;AA4KI;EACE,2BAAA;EACA,0CAAA;AA1KN;AA2KM;EACE,WAAA;AAzKR;AA2KM;EACE,0CAAA;AAzKR;AA6KE;EACE,2BAAA;AA3KJ;AA4KI;EACE,2BAAA;AA1KN;AA4KI;EACE,sBAAA;EACA,0CAAA;AA1KN;AA2KM;EACE,UAAA;AAzKR;AA2KM;EACE,sBAAA;AAzKR;AA4KI;EACE,sBAAA;EACA,0CAAA;AA1KN;AA4KI;EACE,sBAAA;EACA,0CAAA;AA1KN;AA2KM;EACE,iCAAA;EACA,sBAAA;AAzKR;AA0KQ;EACE,cAAA;AAxKV;AA4KI;EACE,mBAAA;AA1KN;AA4KI;EACE,8CAAA;EACA,mBAAA;EACA,gBAAA;AA1KN;AA6KE;EACE,6BAAA;AA3KJ;AA4KI;EACE,oCAAA;AA1KN;AA4KQ;EACE,WAAA;AA1KV;AA6KU;EACE,cAAA;AA3KZ;AAiLE;EACE,mBAAA;AA/KJ;AAgLI;EACE,mBAAA;AA9KN;AA+KM;EACE,8BAAA;AA7KR;AAkLQ;EACE,UAAA;AAhLV;AAqLE;EACE,mBAAA;AAnLJ;AAqLM;EACE,UAAA;AAnLR;AAqLM;EACE,WAAA;AAnLR;AAwLE;EACE,oCAAA;AAtLJ;AAuLI;EACE,uCAAA;AArLN;AAsLM;EACE,+BAAA;AApLR;AAsLM;EACE,kCAAA;AApLR;AAsLM;EACE,cAAA;AApLR;AA0LI;EACE,+BAAA;AAxLN;AA0LI;EACE,kCAAA;AAxLN;AA0LI;EACE,cAAA;AAxLN;AA2LE;EACE,iDAAA;AAzLJ;AA0LI;EACE,6BAAA;AAxLN;AA2LE;EACE,sBAAA;EACA,0CAAA;AAzLJ;AA2LE;EACE,sBAAA;AAzLJ;AA2LE;EACE,yBAAA;AAzLJ;AA0LI;EACE,0CAAA;AAxLN;AA2LE;EACE,6BAAA;EACA,WAAA;AAzLJ;AA4LE;EACE,qDAAA;AA1LJ;AA6LE;EACE,0CAAA;AA3LJ;AA4LI;EACE,UAAA;AA1LN;AA6LE;EACE,8BAAA;EACA,4DAAA;AA3LJ;AA6LM;EACE,UAAA;AA3LR;AA+LM;EACE,8BAAA;AA7LR;AAmMI;EACE,yBAAA;EACA,0CAAA;AAjMN;AAoMI;EACE,gBAAA;EACA,0CAAA;AAlMN;AAqMI;EACE,yBAAA;EACA,8BAAA;AAnMN;AAoMM;EACE,UAAA;AAlMR;AAoMM;EACE,WAAA;AAlMR;AAsMM;EACE,oCAAA;AApMR;AAsMM;EACE,oCAAA;EACA,qDAAA;AApMR;AAuMQ;EACE,cAAA;EACA,0CAAA;AArMV;AA0MM;EACE,sEAAA;AAxMR;AA0MM;EACE,iCAAA;AAxMR;AA0MM;EACE,8BAAA;AAxMR;AA0MM;EACE,iDAAA;AAxMR;AA0MM;EACE,oCAAA;AAxMR;AAyMQ;EACE,sBAAA;AAvMV;AAyMQ;EACE,yBAAA;AAvMV;AA0MU;EACE,UAAA;AAxMZ;AA6MM;;;EAGE,mBAAA;AA3MR;AA6MM;EACE,+CAAA;AA3MR;AA8MQ;EACE,UAAA;AA5MV;AA+MM;EACE,+BAAA;AA7MR;AA+MM;EACE,8CAAA;EACA,oCAAA;EACA,yDAAA;AA7MR;AA+MM;EACE,0CAAA;AA7MR;AA8MQ;EACE,oCAAA;AA5MV;AA+MQ;EACE,gDAAA;EACA,oCAAA;EACA,gBAAA;EACA,WAAA;AA7MV;AA8MU;EACE,UAAA;AA5MZ;AAgNM;EACE,oCAAA;AA9MR;AA+MQ;EACE,WAAA;AA7MV;AAgNM;EACE,0CAAA;AA9MR;AA+MQ;EACE,UAAA;AA7MV;AAgNM;EACE,iDAAA;AA9MR","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700&family=Montserrat:wght@700&family=Poppins:wght@100;200;300;400;500;600;700&display=swap');\n\n.main-full-container{\n  background: #e6e8ec;\n}\n\n:root {\n  --gray-300: #d0d5dd;\n  --gray-500: #667085;\n  --white: #ffffff;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n  color: #444;\n  font-family: 'Poppins', sans-serif;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n  cursor: default;\n}\n\n.default-cursor {\n  cursor: default;\n}\n\n.svg-container:hover path {\n  fill: #007eff;\n}\n\n.tooltip-container:hover path {\n  fill: #000;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  border-radius: 8px;\n  background: rgba(207, 207, 207, 0.22);\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  border: 1px solid var(--gray-300, #e6e6e6);\n  background: #fff;\n}\n\n// .css-tkil2v-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {\n//   color: #000 !important;\n// }\n\n.white-focusable{\n  outline: none;\n  &:focus{\n    box-shadow: 0 0 10px 5px rgba(255, 255, 255, 0.7);\n    border-radius: 5%;\n  }\n}\n\n.blue-focusable{\n  outline: none;\n  &:focus{\n    box-shadow: 0 0 10px 5px rgba(0, 123, 255, 0.5); \n    border-radius: 5%;\n  }\n}\n\n.css-1ufnqyr-MuiFormControl-root-MuiTextField-root {\n  width: 170px !important;\n}\n\nul li.MuiButtonBase-root.MuiMenuItem-root.MuiTablePagination-menuItem {\n  color: #000;\n}\n\n.orange-bg {\n  background-image: url('./images/svg/orange.svg');\n  background-repeat: no-repeat;\n  background-size: 212px 212px;\n}\n.green-bg {\n  background-image: url('./images/svg/greenbg.svg');\n  background-repeat: no-repeat;\n  background-size: 212px 212px;\n}\n.error-bg {\n  background-image: url('./images/svg/errorbg.svg');\n  background-repeat: no-repeat;\n  background-size: 212px 212px;\n}\n.MuiTextField-root {\n  background: none !important;\n}\n.MuiMenuItem-root.Mui-selected {\n  background: none !important;\n}\n .MuiSnackbar-root {\n  z-Index:1800 \n}\n\n.MuiBackdrop-root {\n  opacity: 0.75 !important;\n  background: #000 !important;\n}\n\n.MuiBackdrop-invisible{\n  opacity: 1 !important;\n  background: transparent !important;\n}\n\n//Loadeing-icon-login-page\n.rotating-icon {\n  animation: rotate 1s infinite linear;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.MuiMenu-paper {\n  ul.MuiList-root{\n    li{\n      color: #000;\n    }\n  }\n}\n\n.MuiAppBar-positionFixed.mui-fixed {\n  height: calc(50px + 2vw);\n}\n\n// .MuiDrawer-paperAnchorLeft {\n//   .MuiListItemButton-root{\n//     height: calc(50px + 2vw) !important;\n//   }\n// }\n\n.main-full-container{\n  margin-top: calc(50px + 1.5vw) !important;\n}\n\n@media (max-width: 1710px) {\n  div.expand-domain-ui,\n  div.expand-domain-setup-ui{\n    gap: 60px;\n  }\n}\n\n@media (max-width: 1629px){\n  .setup-complete-title{\n    font-size: 50px !important;\n  }\n}\n\n@media (max-width: 1521px){\n  .setup-complete-title{\n    font-size: 30px !important;\n  }\n  .setup-complete-subtitle{\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 1391px){\n  div.expand-domain-ui, \n  div.expand-domain-setup-ui{\n    .setup-complete-title{\n      font-size: 40px !important;\n    }\n    flex-wrap: nowrap;\n  }\n}\n\n@media (max-width: 2560px){\n  div[data-testid=\"adv-setup-stepper\"]{\n    span.MuiStepConnector-line{\n      min-height: 58px !important;\n    }\n  }\n}\n\n@media (max-width: 1472px){\n  div.create-domain-setup-left-stepper{\n    padding: 30px 60px;\n    min-width: 375px;\n    max-width: 375px;\n  }\n}\n\n@media (max-width: 1280px){\n  .create-organization,\n  .create-application,\n  .create-permission,\n  .create-role{\n    gap: 20px !important;\n    .caption-boxes{\n      width: 35%;\n    }\n  }\n}\n\n@media (max-width: 1440px)  {\n  div[data-testid=\"adv-setup-stepper\"]{\n    .MuiStepLabel-label, .Mui-active, .Mui-completed{\n      font-size: 12px !important;\n    }\n    span.MuiStepConnector-line{\n      min-height: 24px !important;\n    }\n  }\n  div.expand-domain-ui,\n  div.expand-domain-setup-ui{\n    gap: 40px;\n    .MuiStepLabel-label, .Mui-active, .Mui-completed{\n      font-size: 14px !important;\n    }\n  }\n  div.create-domain-setup-left-stepper{\n    padding: 30px 60px;\n    min-width: 375px;\n    max-width: 375px;\n  }\n  div.create-domain-left-stepper{\n    padding: 30px 50px;\n    max-width: 300px;\n    .MuiStepLabel-label, .Mui-active{\n      font-size: 14px !important;\n    }\n  }\n  div.create-domain-right{\n    div.create-form-wrapper{\n      gap: 20px;\n      .step-container{\n        height: 30px;\n      }\n    }\n    .step-name{\n      font-size: 12px !important;\n    }\n  }\n  div[data-testid=\"create-group\"],\n  div[data-testid=\"assign-users-to-org\"],\n  div[data-testid=\"map-per-to-role\"],\n  div[data-testid=\"map-role-to-user\"]{\n    overflow: auto;\n  }\n  div.create-domain-adv-right{\n    div.create-form-wrapper{\n      gap: 20px;\n      .step-container{\n        height: 30px;\n      }\n      .step-name{\n        font-size: 12px !important;\n      }\n      .create-domain-step,\n      .user-onboarding,\n      .create-organization{\n        height: calc(100vh - 310px);\n      }\n      .create-application{\n        height: calc(100vh - 415px);\n        .border-dark{\n          margin: 15px 0px 15px 0px;\n        }\n      }\n      .create-permission,\n      .create-role{\n        min-height: calc(100vh - 375px);\n      }\n      .create-group,\n      .assign-user-to-org{\n        min-height: calc(100vh - 320px);\n      }\n      .map-per-to-roles,\n      .map-role-to-user{\n        min-height: calc(100vh - 300px);\n        button[data-testid=\"add-btn\"]{\n          height: 40px !important;\n          font-size: 12px;\n        }\n      }\n      .choose-wrapper{\n        height: auto;\n        button.create-form-btn{\n          height: 35px;\n        }\n      }\n      div.top-left-btns{\n        .MuiOutlinedInput-root{\n          height: 40px !important;\n        }\n        .filter-btn{\n          height: 40px !important;\n          width: 40px !important;\n        }\n        button[data-testid=\"add-btn\"]{\n          height: 40px !important;\n          font-size: 12px;\n        }\n      }\n      div.top-right-btns{\n        button[data-testid=\"remove-btn\"],\n        button[data-testid=\"remove-admin-btn\"],\n        button[data-testid=\"promote-admin-btn\"]{\n          height: 40px !important;\n          font-size: 12px;\n        }\n      }\n      .empty-space{\n        height: 40px !important;\n      }\n      div[data-testid=\"group-left-side\"], div[data-testid=\"group-right-side\"],\n      div[data-testid=\"org-left-side\"], div[data-testid=\"org-right-side\"],\n      div[data-testid=\"permap-left-side\"],div[data-testid=\"permap-right-side\"],\n      div[data-testid=\"rolemap-left-side\"],div[data-testid=\"rolemap-right-side\"]{\n        gap: 16px;\n        .custom-pagination{\n          height: 50px;\n          .MuiTablePagination-root{\n            margin-left: 0px;\n            button[aria-label=\"previous page\"],\n            button[aria-label=\"next page\"]{\n              height: 40px !important;\n              margin-top: 7px;\n              font-size: 14px !important;\n            }\n          }\n        }\n        .setup-checkbox-button{\n          .button-content{\n            display: none;\n          }\n        }\n      }\n      div.footer-buttons{\n        button.cross-btn,\n        button[data-testid=\"tick-btn\"],\n        button[data-testid=\"left-btn\"],\n        button[data-cy=\"right-btn\"]{\n          width: 40px;\n          height: 40px;\n          padding: 10px;\n        }\n      }\n    }\n  }\n  div.search-export-section{\n    .search-bar{\n      width: 260px;\n    }\n  }\n  .main-full-container{\n    margin-top: calc(50px + 1vw) !important;\n  }\n  .outlet-box{\n    max-height: calc(100vh - 200px);\n  }\n  .MuiAppBar-positionFixed.mui-fixed{\n    height: 70px;\n    .MuiBreadcrumbs-li{\n      &>div{\n        font-size: 14px;\n      }\n    }\n    a.MuiListItemButton-root{\n      height: 70px !important;\n    }\n  }\n  .MuiDrawer-paperAnchorLeft {\n    .MuiListItemButton-root{\n      height: 70px !important;\n    }\n  }\n  .create-user-page{\n    height: calc(100vh - 120px);\n    overflow: auto;\n  }\n  .roles-permission-list{\n    height: calc(100vh - 382px) !important;\n  }\n  .main-sub-container{\n    height: calc(100vh - 200px);\n    overflow: auto;\n  }\n  .custom-pagination{\n    padding: 8px 16px !important;\n  }\n  .user-panel-table{\n    height: calc(100vh - 300px) !important;\n  }\n  .panel-table{\n    height: calc(100vh - 300px) !important;\n  }\n  div[data-testid=\"dom-admin-left-panel\"], div[data-testid=\"prev-right-panel\"],\n  div[data-testid=\"left-panel\"],\n  div[data-testid=\"right-panel\"], \n  div[data-testid=\"adv-api-mgmt\"],\n  div.main-side-drawer{\n    max-height: calc(100vh - 200px);\n    min-height: calc(100vh - 200px);\n  }\n  div.create-group-form{\n    height: calc(100vh - 300px) !important;\n  }\n  div.main-side-drawer{\n    gap: 8px;\n  }\n  div.drawer-header{\n    padding: 0px;\n  }\n  div.resource-table{\n    max-height: calc(100vh - 510px);\n  }\n  div.subscriber-table{\n    height: calc(100vh - 530px);\n  }\n  div[data-testid=\"main-auth-container\"]{\n    height: calc(100vh - 140px);\n  }\n  div[data-testid=\"domadmins-list\"]{\n    div.user-div{\n      .user-div{\n        height: 50px;\n      }\n    }\n  }\n  .MuiTablePagination-root{\n    .MuiTablePagination-toolbar{\n      padding-left: 0px !important;\n    }\n    .MuiTablePagination-selectLabel, .MuiTablePagination-select,\n    .MuiTablePagination-displayedRows{\n      font-size: 14px !important;\n    }\n    .MuiTablePagination-input{\n      margin-right: 20px !important;\n    }\n    div.MuiBox-root{\n      margin-left: 20px !important;\n      button[aria-label=\"next page\"]{\n        margin-left: 20px !important;\n      }\n    }\n  }\n}\n\nbody[data-theme=\"dark\"]{\n  .main-full-container{\n    background: #111;\n  }\n  div#root>div{\n    background: #111;\n    color: #FFF;\n  }\n  .svg-container path {\n    fill: #FFF;\n  }\n  .svg-container{\n    &:hover{\n      path {\n        fill: #007eff;\n      }\n    }\n  }\n  //header theme\n  header {\n    background-color: #1B1B1B;\n    .MuiBreadcrumbs-ol {\n      .MuiBreadcrumbs-li div.last-crumb{\n        color: var(--gray-white, #FFF);\n      }\n      li.MuiBreadcrumbs-separator svg path{\n        fill: var(--gray-white, #FFF);\n      }\n    }\n    .head-dom-name{\n      border: none;\n      background: #2F2F2F;\n      svg path{\n        stroke: var(--gray-white, #FFF);\n      }\n      p{\n        color: #FFF;\n      }\n    }\n    button[aria-controls=\"primary-search-account-menu\"]{\n      border-left: 1px solid rgba(255, 255, 255, 0.10);\n      &:hover{\n        background: #2F2F2F;\n      }\n    }\n  }\n  //sidebarV3 theme\n  .MuiDrawer-paper {\n    background-color: #1B1B1B;\n    div.select-org-dropdown{\n      background: #272727 !important;\n      box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.15) !important;\n      nav div{\n        color: #FFF !important;\n        &:hover{\n          background: #4c4c4c !important;\n        }\n      }\n    }\n    .MuiGrid-direction-xs-column {\n      color: #f6f6f6;\n    }\n    li{\n      svg path{\n        fill: #fff;\n      }\n      &>div.MuiListItemButton-root{\n        color: #fff;\n        &:hover{\n          color: #175CE5;\n          path {\n            fill: #175CE5;\n          }\n        }\n      }\n      &>div.domain-mgmt{\n        color: #fff;\n        svg path {\n          fill: none;\n          stroke: #fff;\n        }\n        &:hover{\n          color: #175CE5;\n          path {\n            fill: none;\n            stroke: #175CE5;\n          }\n        }\n      }\n    }\n    li.selected{\n      &>div{\n        color: #175CE5;\n      }\n      &>div.domain-mgmt{\n        svg path {\n          fill: none;\n          stroke: #175CE5;\n        }\n      }\n      svg path{\n        fill: #175CE5;\n      }\n    }\n  }\n  //Input fields\n  label, p[data-testid=\"right-header\"]{\n    color: #fff;\n  }\n  div.search-export-section{\n    .MuiInputBase-root{\n      border: 1px solid rgba(226, 232, 240, 0.06);\n      background: #1B1B1B;\n      box-shadow: 1px 2px 6px 0px rgba(180, 191, 205, 0.06);\n      input.MuiInputBase-input{\n        color: #fff;\n        &::placeholder{\n          color: #8E92A0;\n        }\n      }\n    }\n  }\n  //input fields\n  div.normal-border {\n    div.MuiOutlinedInput-root{\n      background-color: #111;\n      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n      .MuiOutlinedInput-notchedOutline, \n      .MuiOutlinedInput-root.Mui-focused fieldset{\n        border: 1px solid var(--gray-800, #404040);\n      }\n      &:hover{\n        fieldset{\n          border: 1px solid var(--gray-800, #404040);\n        }\n      }\n      input.MuiInputBase-input{\n        color: #fff;\n        &::placeholder{\n          color: #8E92A0;\n        }\n      }\n      .MuiInputAdornment-positionEnd{\n        svg path{\n          fill: #fff;\n        }\n      }\n    }\n  }\n  div.error-border {\n    div.MuiOutlinedInput-root{\n      background-color: #111;\n      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n      .MuiOutlinedInput-notchedOutline, \n      .MuiOutlinedInput-root.Mui-focused fieldset{\n        border: 1px solid #F27A7A;\n      }\n      &:hover{\n        fieldset{\n          border: 1px solid #F27A7A;\n        }\n      }\n      input.MuiInputBase-input{\n        color: #fff;\n        &::placeholder{\n          color: #8E92A0;\n        }\n      }\n    }\n  }\n  textarea{\n    border: 1px solid var(--gray-800, #404040);\n    background: #111;\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    color: #fff;\n    &::placeholder{\n      color: #8E92A0;\n    }\n    &:disabled{\n      border: 1px solid var(--gray-800, #404040);\n      background: #111;\n    }\n  }\n  //search-input\n  div.search-input{\n    input.MuiInputBase-input{\n      color: #fff;\n      &::placeholder{\n        color: #8E92A0;\n      }\n    }\n    div.MuiOutlinedInput-root{\n      border: 1px solid var(--gray-800, #404040);\n      background-color: #111;\n      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    }\n    .MuiInputAdornment-root{\n      svg {\n        color: #fff;\n      }\n    }\n  }\n  //select-input\n  div.input-select{\n    background: #1B1B1B;\n    // svg path{\n    //   stroke: #fff;\n    // }\n    &-def-input{\n      background: #1B1B1B;\n      .MuiOutlinedInput-notchedOutline{\n        border: 1px solid rgba(208, 213, 221, 0.10);\n        // background: #1B1B1B;\n        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n      }\n      // svg path{\n      //   stroke: #fff;\n      // }\n      div.infoicon{\n        svg path{\n          fill: #fff;\n        }\n      }\n      .MuiSelect-outlined{\n        color: #FFF;\n      }\n    }\n    div.infoicon{\n      svg path{\n        fill: #fff;\n      }\n    }\n    .MuiSelect-outlined{\n      color: #FFF;\n    }\n  }\n  //radio-input\n  div.input-radio{\n    label{\n      color: #FFF !important;\n    }\n  }\n  //date-input\n  input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    filter: invert(1);\n  }\n  //number-input\n  div.input-number{\n    background-color: #111;\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    border: 1px solid var(--gray-800, #404040);\n    button{\n      svg path{\n        fill: #fff;\n      }\n    }\n    input.MuiNumberInput-input{\n      color: #fff;\n      &::placeholder{\n        color: #8E92A0;\n      }\n    }\n  }\n  //phone-input\n  div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(1),\n  div.phone-normal-input div.MuiFormControl-root:nth-child(1){\n    div.MuiInputBase-root{\n      .MuiOutlinedInput-root{\n        background-color: #111;\n      }\n      background-color: #111;\n      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n      border: 1px solid var(--gray-800, #404040);\n      border-right: none !important;\n      .MuiOutlinedInput-notchedOutline{\n        border-right: none;\n      }\n    }\n  }\n  div.phone-normal-input-disabled div.MuiFormControl-root:nth-child(1){\n      div.MuiInputBase-root{\n        color: var(--gray-500, #667085);\n        .MuiSvgIcon-root{\n          path {\n            fill: #667085;\n          }\n        }\n      }\n  }\n  div.phone-normal-input div.MuiFormControl-root:nth-child(1){\n    div.MuiInputBase-root{\n    color: #fff;\n    .MuiSvgIcon-root{\n      path {\n        fill: #fff;\n      }\n    }\n  }\n}\ndiv.phone-normal-input-disabled div.MuiFormControl-root:nth-child(2),\ndiv.phone-normal-input div.MuiFormControl-root:nth-child(2){\n  div.MuiInputBase-root{\n    .MuiOutlinedInput-root{\n      background-color: #111;\n    }\n    background-color: #111;\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    .MuiOutlinedInput-notchedOutline{\n      border: 1px solid var(--gray-800, #404040);\n      border-left: none;\n    }\n  }\n}\ndiv.phone-normal-input-disabled div.MuiFormControl-root:nth-child(2){\n    div.MuiInputBase-root{\n      color: var(--gray-500, #667085);\n      .MuiSvgIcon-root{\n        path {\n          fill: #667085;\n        }\n      }\n    }\n}\ndiv.phone-normal-input div.MuiFormControl-root:nth-child(2){\n  div.MuiInputBase-root{\n  color: #fff;\n  .MuiSvgIcon-root{\n    path {\n      fill: #fff;\n    }\n  }\n}\n}\n///////\ndiv.phone-error-input-disabled div.MuiFormControl-root:nth-child(1),\n  div.phone-error-input div.MuiFormControl-root:nth-child(1){\n    div.MuiInputBase-root{\n      color: #fff;\n      .MuiSvgIcon-root{\n        path {\n          fill: #fff;\n        }\n      }\n      .MuiOutlinedInput-root{\n        background-color: #111;\n      }\n      background-color: #111;\n      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n      // border: 1px solid var(--gray-800, #404040);\n      border-right: none !important;\n      .MuiOutlinedInput-notchedOutline{\n        border-right: none;\n      }\n    }\n  }\ndiv.phone-error-input-disabled div.MuiFormControl-root:nth-child(2){\n    div.MuiInputBase-root{\n      background-color: #111;\n      .MuiOutlinedInput-root{\n        background-color: #111;\n      }\n      color: var(--gray-500, #667085);\n      .MuiSvgIcon-root{\n        path {\n          fill: #667085;\n        }\n      }\n    }\n}\ndiv.phone-error-input div.MuiFormControl-root:nth-child(2){\n  div.MuiInputBase-root{\n    background-color: #111;\n    .MuiOutlinedInput-root{\n      background-color: #111;\n    }\n  color: #fff;\n  .MuiSvgIcon-root{\n    path {\n      fill: #fff;\n    }\n  }\n}\n}\n  //accordion\n  .MuiAccordionSummary-root {\n    background: #272727 !important;\n    p{\n      color: #fff;\n    }\n    border-bottom: 1px solid rgba(240, 240, 240, 0.10);\n    .MuiAccordionSummary-expandIconWrapper{\n      svg {\n        fill: #fff;\n      }\n    }\n  }\n  .MuiCollapse-root{\n    .accordion-body{\n      border-bottom: 1px solid rgba(240, 240, 240, 0.10);\n      background: var(--gray-800, #404040);\n      svg{\n        rect {\n          fill: var(--gray-900, #242424);\n        }\n        path{\n          fill: #404040;\n        }\n      }\n      .heading {\n        color: var(--gray-white, #FFF);\n      }\n      .sub-heading{\n        color: var(--gray-050, #FAFAFA);\n      }\n    }\n  }\n  //buttons\n  //filter-btn\n  .filter-btn{\n    border: 1px solid rgba(226, 232, 240, 0.10) !important;\n    background: #1B1B1B !important;\n    box-shadow: 1px 2px 4px 0px rgba(180, 191, 205, 0.10) !important;\n    svg path{\n      fill: white;\n    }\n  }\n  //export-btn\n  button[data-cy=\"export-btn\"], button.export-btn{\n    background-color: #2F2F2F !important;\n    color: var(--gray-1-white, #FFF) !important;\n    svg path{\n      fill: #fff;\n    }\n    &:hover{\n      box-shadow: 0px 2px 12px 0px rgba(52, 52, 52, 0.46) !important;\n    }\n  }\n  //hover-btn\n  button[data-cy=\"hover-btn\"]{\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    background-color: #2F2F2F !important;\n    color: var(--gray-1-white, hsl(0, 0%, 100%));\n    svg path{\n      fill: #fff;\n    }\n    &:hover{\n      border: 1px solid #175CE5;\n      svg path{\n        fill: #175CE5;\n      }\n      box-shadow: 0px 2px 12px 0px rgba(52, 52, 52, 0.46) !important;\n      color: #175CE5;\n    }\n  }\n  //add-per-btn\n  button[data-cy=\"add-per-btn\"]{\n    border: none;\n  }\n  //left-arrow-btn\n  button.left-arrow-btn{\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    background: #111;\n    background-blend-mode: multiply;\n    svg path{\n      fill: #fff;\n    }\n    &:hover{\n      background: var(--primary-600, #175CE5);\n      color: #fff\n    }\n    &-reset{\n      border: 1px solid rgba(230, 230, 230, 0.10);\n      background: #111;\n      background-blend-mode: multiply;\n      svg path{\n        fill: #fff;\n      }\n      &:hover{\n        background: #CC1F1F;\n        color: #fff;\n      }\n    }\n  }\n  //tick-btn\n  button[data-testid=\"tick-btn\"]{\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    background: #111;\n    background-blend-mode: multiply;\n    svg path{\n      fill: #fff;\n    }\n    &:hover{\n      background: var(--primary-600, #175CE5);\n      color: #fff\n    }\n  }\n  //cross-btn{\n  button.cross-btn, div.cross-btn{\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    background: #111;\n    background-blend-mode: multiply;\n    svg path{\n      fill: #fff;\n    }\n    &:hover{\n      background: var(--danger-600, #CC1F1F);\n      color: #fff\n    }\n  }\n  button.delete-btn{\n    &:disabled{\n      svg path:nth-child(2){\n        fill: #5c5b5b;\n      }\n    }\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    background-color: #242424;\n    background-blend-mode: multiply;\n    svg path:nth-child(2){\n      fill: #fff;\n    }\n    &:hover{\n      background: var(--danger-600, #CC1F1F);\n      color: #fff\n    }\n  }\n  //add-admin-btn\n  button[data-cy=\"add-admin-btn\"].def-btn{\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    background: #1B1B1B;\n    color: var(--gray-1-white, #FFF);\n    &:hover{\n      border: 1px solid #175CE5;\n      color: #175CE5;\n    }\n  }\n  button[data-cy=\"add-admin-btn\"].add-btn, button[data-cy=\"add-admin-btn\"].remove-btn, button[data-testid=\"done-btn\"].export-btn, button.export-btn,\n  button[data-testid=\"promote-admin-btn\"]{\n    border: none;\n  }\n  //remove-admin-btn\n  button[data-testid=\"remove-admin-btn\"]{\n    border: none;\n    background-color: #2F2F2F !important;\n    color: var(--gray-1-white, #FFF) !important;\n    &:hover{\n      box-shadow: 0px 2px 12px 0px rgba(52, 52, 52, 0.46) !important;\n    }\n  }\n  //upload-csv-btn\n  div.upload-btn, button.upload-btn, button[data-cy=\"upload-btn\"]{\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    background: #1B1B1B !important;\n    color: var(--gray-1-white, #FFF);\n    svg path{\n      fill: #fff;\n    }\n    p{\n      color: var(--gray-1-white, #FFF);\n    }\n    &:hover{\n      border: 1px solid #175CE5;\n      svg path{\n        fill: #175CE5 !important;\n      }\n      p{\n        color: var(--gray-1-white, #175CE5);\n      }\n    }\n  }\n  //plus-blue-btn\n  button.plus-btn{\n    background-color: var(--btn-01-primary-enabled, #2469F3) !important;\n  }\n  //create-api-tab-btns\n  button.create-tab-btn {\n    border: 1px solid rgba(230, 230, 230, 0.10);\n    color: var(--gray-1-white, #FFF);\n    svg path{\n      fill: #fff;\n    }\n    p{\n      color: var(--gray-1-white, #FFF);\n    }\n    &-selected {\n      background: var(--btn-01-primary-enabled, #2469F3);\n    }\n    &-not-selected {\n      background: #1B1B1B;\n      &:hover{\n        border: 1px solid #175CE5;\n        svg path{\n          fill: #175CE5 !important;\n        }\n        p{\n          color: var(--gray-1-white, #175CE5);\n        }\n      }\n    }\n  }\n  //confirm-popup-btns\n  button.confirm{\n    &-yes-btn{\n      border: none;\n    }\n    &-no-btn{\n      border: 1px solid rgba(208, 213, 221, 0.05);\n      background: #2F2F2F;\n      color: #fff;\n      &:hover{\n        border: 1px solid rgba(208, 213, 221, 0.05);\n        background: #2F2F2F;\n      }\n    }\n  }\n  //add-user-top-btns{\n    button.add-user-top-btns{\n      &-org{\n        &:hover{\n          background-color: #171B2A !important;\n          color: #3D79F2 !important;\n          svg path{\n            fill: #3D79F2;\n          }\n        }\n      }\n      &-role{\n        &:hover{\n          background-color: #203723 !important;\n          color: #1F992F !important;\n          svg path{\n            fill: #1F992F;\n          }\n        }\n      }\n      &-group{\n        &:hover{\n          background-color: #251536 !important;\n          color: #864CBF !important;\n          svg path{\n            fill: #864CBF;\n          }\n        }\n      }\n    }\n  //users-list\n  div.users-list{\n    background: var(--gray-900, #242424);\n    div.user-div{\n      background: var(--gray-900, #242424);\n    }\n  }\n  div.users-list-nill{\n    background-color: transparent !important;\n  }\n  div.user-div{\n    background: var(--gray-900, #242424);\n  }\n  div.list-user{\n    &-white{\n      background: #111 !important;\n    }\n    &-select{\n      background: #292929 !important;\n    }\n    &-dark{\n      background: var(--gray-900, #242424);\n    }\n  }\n  .MuiMenu-paper {\n    border: 1px solid rgba(191, 191, 191, 0.10);\n    background: #272727;\n    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.15);\n    ul.MuiList-root{\n      li{\n        color: #FFF;\n        svg path{\n          fill: #fff;\n        }\n        &:hover{\n          background: #2F2F2F;\n        }\n      }\n    }\n  }\n  .MuiTableContainer-root {\n    .MuiTable-root {\n      .MuiTableHead-root {\n        .MuiTableCell-head {\n          background: #181818;\n          color: var(--gray-white, #FFF); \n          .MuiTableSortLabel-root{\n            svg path{\n              fill: #fff;\n            }\n            &:hover{\n              color: var(--gray-white, #FFF);\n            }\n          }       \n        }\n      }\n      .MuiTableBody-root {\n        .MuiTableRow-root{\n          border-bottom: 1px solid rgba(64, 64, 64, 0.50);\n          background: #1B1B1B;\n          box-shadow: none;\n          td{\n            border-bottom: 1px solid rgba(64, 64, 64, 0.50);\n            color: var(--gray-white, #FFF);\n            span.normal{\n              color: var(--gray-white, #FFF) !important;\n            }\n            div.app-type{\n              color: #14b2b2;\n            }\n          }\n          &:hover{\n            background-color: #101010;\n          }\n          &.Mui-selected{\n            background-color: #292929;\n          }\n        }\n      }\n    }\n  }\n  //leftpanel \n  div[data-testid=\"left-panel\"],\n  div[data-testid=\"blank-panel\"],\n  div[data-testid=\"dom-admin-left-panel\"], \n  div[data-testid=\"right-panel\"], \n  div[data-testid=\"right-panel\"]>div.blank-panel,\n  div[data-testid=\"adv-api-mgmt\"],\n  div[data-testid=\"app-blank-panel\"],\n  div[data-testid=\"prev-right-panel\"],\n  div[data-testid=\"main-auth-container\"],\n  div[data-testid=\"create-users-blank-panel\"],\n  div[data-testid=\"domadmin-left-panel-header\"]{\n    background-color: #1B1B1B;\n    color: var(--gray-white, #FFF);\n  }\n  div[data-testid=\"right-panel\"]>div.blank-panel, div[data-testid=\"blank-panel\"], div[data-testid=\"create-users-blank-panel\"]{\n    svg path{\n      fill: #fff;\n    }\n    p {\n      color: #fff;\n    }\n  }\n  div[data-testid=\"domadmin-left-panel-header\"]{\n    p{\n      color: var(--gray-white, #FFF);\n    }\n  }\n  p[data-testid='left-panel-title'], .list-count{\n    color: var(--gray-white, #FFF);\n  }\n  div.chip-active{\n    background-color: #193C1E;\n    span{\n      color: #B0FFC3;\n    }\n  }\n  div.chip-inactive{\n    background-color: #4D3234;\n    span{\n      color: #FF7296;\n    }\n  }\n  div.chip{\n    background-color: #242424;\n    &-lock{\n    }\n    &-unlock{\n      color: #fff;\n      svg path{\n        fill: #fff;\n      }\n    }\n  }\n  div.chips{\n    &-Organizations{\n      background: #171B2A;\n      .MuiChip-label{\n        color: var(--Main, #5D5FEF);\n      }\n    }\n    &-Roles{\n      background: #203723;\n      .MuiChip-label{\n        color: var(--success-600, #24B237);\n      }\n    }\n    &-Groups{\n      background: #251536;\n      .MuiChip-label{\n        color: var(--secondary-600, #6B24B2);\n      }\n    }\n    &-trans{\n      .MuiChip-label{\n        color: #fff;\n      }\n    }\n  }\n  //custom-pagination\n  div.custom-pagination{\n    background-color: #252525 !important;\n    .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows{\n      color: var(--gray-white, #FFF);\n    }\n    .MuiTablePagination-select{\n      color: var(--gray-white, #FFF);\n      &:focus{\n        background-color: #252525 !important;\n      }\n    }\n    .MuiTablePagination-selectIcon{\n      fill: #fff;\n    }\n    button[aria-label=\"previous page\"], button[aria-label=\"next page\"]{\n      border: 1px solid rgba(226, 232, 240, 0.12);\n      background: #1B1B1B;\n      &:disabled{\n        color: #505B69;\n        svg path{\n          stroke: #505B69;\n        }\n      }\n      &:hover{\n        background: #1f1f1f;\n      }\n    }\n  }\n  //switch\n  .MuiSwitch-track{\n    background-color: #404040;\n  }\n  .MuiSwitch-thumb{\n    background-color: #242424;\n  }\n  .empty-list{\n    background-color: #242424;\n    p {\n      color: var(--gray-white, #FFF);\n    }\n  }\n  .app-type{\n    color: #14b2b2;\n    .MuiChip-label{\n      color: #14b2b2;\n    }\n  }\n  .org-badge{\n    background: #171B2A;\n    .MuiChip-label{\n      color: var(--Main, #5D5FEF);\n    }\n  }\n  .role-badge{\n    background: #203723;\n    .MuiChip-label{\n      color: var(--success-600, #24B237);\n    }\n  }\n  .group-badge{\n    background: #251536;\n    .MuiChip-label{\n      color: var(--secondary-600, #6B24B2);\n    }\n  }\n  .popup-container{\n    border-radius: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.50);\n    background: #161616;\n    .create-form-container{\n      border: 1px solid rgba(230, 230, 230, 0.10);\n    }\n  }\n  .view-users-popup{\n    background: #111;\n    .MuiPaper-rounded{\n      background: #111;\n    }\n    .MuiTableRow-head{\n      background: #111;\n    }\n    .MuiTableBody-root .MuiTableRow-root td{\n      border-bottom: none !important;\n    }\n    button.view-edit-btn{\n      svg {\n        color: #fff;\n      }\n    }\n  }\n  .group-filter-popup>div{\n    background: #111 !important;\n    .filter-header{\n      svg path{\n        fill: #fff;\n      }\n      p{\n        color: #fff !important;\n      }\n    }\n    button.left-btn, button.right-btn{\n      border: 1px solid rgba(226, 232, 240, 0.10);\n      background: #111;\n      box-shadow: none;\n      svg path{\n        stroke: white;\n      }\n    }\n  }\n  .confirm-popup-container{\n    border-radius: 16px;\n    border: 1px solid rgba(255, 253, 253, 0.50);\n    background: #1B1B1B;\n    p{\n      color: #fff;\n    }\n    .create-form-container{\n      border: 1px solid rgba(230, 230, 230, 0.10);\n    }\n  }\n  button.edit-btn{\n    border: 1px solid rgba(208, 213, 221, 0.10);\n    background-color: #242424;\n    background-blend-mode: multiply;\n    svg{\n      color: #fff !important;\n    }\n    &:hover{\n      background-color: #2469F3;\n    }\n  }\n  div.upload-main-heading{\n    svg path{\n      fill: #fff;\n    }\n    p{\n      color: #fff;\n    }\n  }\n  div[data-testid=\"main-auth-container\"]{\n    &>p{\n      color: #fff;\n    }\n    div.auth-containers{\n      background: #111 !important;\n      border: 1px solid rgba(226, 232, 240, 0.10);\n      &>p{\n        color: #fff;\n      }\n      div.option-box{\n        border: 1px solid rgba(226, 232, 240, 0.10);\n      }\n    }\n  }\n  div.main-side-drawer{\n    background: #111 !important;\n    .drawer-header{\n      background: #111 !important;\n    }\n    .time-updates{\n      background-color: #111;\n      border: 1px solid var(--gray-800, #404040);\n      svg path{\n        fill: #fff;\n      }\n      p{\n        color: #fff !important;\n      }\n    }\n    .input-policy{\n      background-color: #111;\n      border: 1px solid var(--gray-800, #404040);\n    }\n    .tags{\n      background-color: #111;\n      border: 1px solid var(--gray-800, #404040);\n      input{\n        background-color: #111 !important;\n        color: #fff !important;\n        &::placeholder{\n          color: #8E92A0;\n        }\n      }\n    }\n    .res-table-header{\n      background: #181818;\n    }\n    .res-table-row{\n      border-bottom: 1px solid rgba(64, 64, 64, 0.50);\n      background: #1B1B1B;\n      box-shadow: none;\n    }\n  }\n  .subscr-div{\n    background-color: transparent;\n    &-list{\n      background: var(--gray-900, #242424);\n      .delete-app{\n        svg{\n          color: #fff;\n        }\n        &:hover{\n          svg {\n            color: #CC1F1F;\n          }\n        }\n      }\n    }\n  }\n  .toggle-tabs{\n    background: #2F2F2F;\n    .MuiToggleButton-root{\n      background: #2F2F2F;\n      span{\n        color: var(--gray-white, #FFF);\n      }\n    }\n    .MuiBadge-root{\n      .MuiBadge-badge {\n        svg path{\n          fill: #fff;\n        }\n      }\n    }\n  }\n  .main-portal-tabs{\n    background: #2F2F2F;\n    div.not-select{\n      svg path{\n        fill: #fff;\n      }\n      p{\n        color: #fff;\n      }\n    }\n  }\n  //adv-api-mgmt-cards\n  div.normal-card{\n    background: var(--gray-900, #242424);\n    &:hover{\n      background: var(--primary-050, #E0E9FA);\n      p.list-count {\n        color: var(--gray-900, #101828);\n      }\n      p.created-by, p.card-details{\n        color: var(--primary-900, #051433);\n      }\n      svg.delete-icon{\n        color: #242424;\n      }\n    }\n  }\n  //select-card\n  div.select-card{\n    p.list-count {\n      color: var(--gray-900, #101828);\n    }\n    p.created-by, p.card-details{\n      color: var(--primary-900, #051433);\n    }\n    svg.delete-icon{\n      color: #242424;\n    }\n  }\n  div.side-drawer-tabs{\n    border-bottom: 1px solid var(--gray-800, #404040);\n    .Mui-selected.MuiToggleButton-root{\n      background-color: transparent;\n    }\n  }\n  div.label-with-chips{\n    background-color: #111;\n    border: 1px solid var(--gray-800, #404040);\n  }\n  div.user-reset-pwd{\n    background-color: #111;\n  }\n  div.create-form-wrapper{\n    background-color: #1B1B1B;\n    .radio-btn-wrapper{\n      border: 1px solid var(--gray-800, #404040);\n    }\n  }\n  div.caption-box{\n    background-color: transparent;\n    color: #fff;\n  }\n  //create-user\n  .border-dark{\n    border: 1px solid var(--gray-800, #404040) !important;\n  }\n  //quickstart\n  div.quick-app-container{\n    border: 1px solid var(--gray-800, #404040);\n    svg path{\n      fill: #fff;\n    }\n  }\n  div.MuiPopover-paper{\n    background: #272727 !important;\n    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.15) !important;\n    nav div:nth-child(1){\n      svg path{\n        fill: #fff;\n      }\n    }\n    nav div{\n      &:hover{\n        background: #4c4c4c !important;\n      }\n    }\n  }\n  //adv-domain-setup\n    //choose-wrapper\n    div.choose-wrapper{\n      background-color: #1B1B1B;\n      border: 1px solid var(--gray-800, #404040);\n    }\n    //mid-containers\n    .mid-container{\n      background: #111;\n      border: 1px solid rgba(230, 230, 230, 0.10);\n    }\n    //blank-panel\n    div.blank-panel{\n      background-color: #1B1B1B;\n      color: var(--gray-white, #FFF);\n      svg path{\n        fill: #fff;\n      }\n      p {\n        color: #fff;\n      }\n    }\n    //auth-screens\n      .dark-bg{\n        background-color: #1B1B1B !important;\n      }\n      .dark-with-border{\n        background-color: #1B1B1B !important;\n        border: 1px solid rgba(230, 230, 230, 0.10) !important;\n      }\n      button.button-wrapper{\n        &:disabled{\n          color: #505B69;\n          border: 1px solid rgba(230, 230, 230, 0.10);\n        }\n      }\n\n      //skeleton-loading\n      .dark-skeleton{\n        background-image: linear-gradient(90deg, #333 0%, #666 50%, #333 100%);\n      }\n      .central-items{\n        background-color: #111 !important;\n      }\n      .light-dark{\n        background: #504e4e !important;\n      }\n      .graph-border{\n        border-bottom: 1px solid rgba(230, 230, 230, 0.10);\n      }\n      div[data-testid=\"toast-message\"]{\n        background-color: #1B1B1B !important;\n        p[data-testid=\"toast-heading\"]{\n          color: #fff !important;\n        }\n        p[data-testid=\"toast-description\"]{\n          color: #adbbd0 !important;\n        }\n        svg.copy-icon, svg.cross-icon{\n          path{\n            fill: #fff;\n          }\n        }\n      }\n      //dashboard\n      div.feature-counts-box, div.pie-chart-card,\n      div.stats-widget, div.graph-main-widget, \n      div.aside-panel{\n        background: #1B1B1B;\n      }\n      div.central-items-content{\n        background: var(--gray-900, #242424) !important;\n      }\n      div.api-app-analytics{\n        svg path{\n          fill: #fff;\n        }\n      }\n      .light-color{\n        color: var(--gray-400, #C2C2C2);\n      }\n      div.analytics-cards{\n        border: 0.546px solid var(--gray-800, #404040);\n        background: var(--gray-900, #242424);\n        box-shadow: 0px 0.546px 1.639px 0px rgba(0, 81, 175, 0.10);\n      }\n      div.duration-tabs{\n        border: 1px solid var(--gray-800, #404040);\n        div.single-tab-selected{\n          background: var(--gray-200, #F0F0F0);\n\n        }\n        div.single-tab-not-selected{\n          border-right: 1px solid var(--gray-800, #404040);\n          background: var(--gray-900, #242424);\n          box-shadow: none;\n          color: #fff;\n          svg path{\n            fill: #fff;\n          }\n        }\n      }\n      div.pill-tabs{\n        background: rgba(233, 235, 253, 0.10);\n        div.single-tab-not-selected{\n          color: #fff;\n        }\n      }\n      button.dashboard-refresh{\n        border: 1px solid rgba(208, 213, 221, 0.10);\n        svg path{\n          fill: #fff;\n        }\n      }\n      div.progress-mgmt{\n        border-bottom: 1px solid var(--gray-800, #404040);\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
